export const headerDataResponse = {
    "jobs": [
        {
            "id": "ceeaa972-6b3c-4243-a24b-bbeb7df0bf42",
            "job_name": "ManualTest_1",
            "user_inputs": "['05bc5498-9d26-45a5-bfa2-c801c6359a7e']",
            "status": "Success",
            "requestDateAndTime": "2024-04-25 14:17:33.065237",
            "processedTime": "452.73214",
            "subJobs": [
                {
                    "id": "f8d68b0f-d17b-468f-b325-7d7c95d061be",
                    "job_name": "ManualTest_1",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['DoorLockPositionRL', 'PCSOpStateBrake', 'VSCControl', 'WheelSpeedRR', 'HazardSwitch', 'DoorOpenP', 'PowerModeSelect_A', 'StopLampControl', 'EcoModeInd', 'TransmissionType', 'RearFogLamp', 'TRCControl', 'TirePressureFL', 'LKAAssist_A', 'TirePressureRR', 'Odo', 'RearDefInd', 'DefogInd', 'DoorLockPositionRR', 'TripCount', 'ACInd', 'AccelFB', 'ParkingBrake', 'SmartBeamInd', 'WindowPositionRL', 'ATShiftPosition', 'BrakePedalPressure', 'BrakePedalInd', 'WindowPositionD', 'WindowPositionRR', 'HoodOpen', 'AccelLR', 'TurnSignal', 'DoorOpenD', 'Speed', 'AngularVelocity', 'RecIndicator', 'AmbientTemp_A', 'ABSControl', 'SteeringAngle_A', 'PowerModeSelect_B', 'WindowPositionP', 'DoorOpenRR', 'SeatBeltD', 'WhiteLineSymbolL_A', 'WheelSpeedFL', 'FrontBlowerLevel', 'PCSOpStateAlarm', 'DoorLockPositionD', 'TirePressureFR', 'HeadLamp_B', 'LKABuzzer_A', 'SportModeSelect', 'WheelSpeedRL', 'StateOfCharge', 'AccelPedalAngle', 'WhiteLineSymbolR_A', 'TirePressureRL', 'TimeCount', 'TailLampStatus', 'TempSettingP', 'DoorLockPositionP', 'TempSettingD', 'LuggageOpen', 'WheelSpeedFR', 'DoorOpenRL']}, {'title': 'job_type', 'value': 'Un Nested Job'}]",
                    "status": "Error",
                    "requestDateAndTime": "2024-05-03 13:02:06.154829",
                    "processedTime": "1e-05"
                },
                {
                    "id": "4356df3f-c756-4216-91e5-457c55704861",
                    "job_name": "ManualTest_1",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['DoorLockPositionRL', 'PCSOpStateBrake', 'VSCControl', 'WheelSpeedRR', 'HazardSwitch', 'DoorOpenP', 'PowerModeSelect_A', 'StopLampControl', 'EcoModeInd', 'TransmissionType', 'RearFogLamp', 'TRCControl', 'TirePressureFL', 'LKAAssist_A', 'TirePressureRR', 'Odo', 'RearDefInd', 'DefogInd', 'DoorLockPositionRR', 'TripCount', 'ACInd', 'AccelFB', 'ParkingBrake', 'SmartBeamInd', 'WindowPositionRL', 'ATShiftPosition', 'BrakePedalPressure', 'BrakePedalInd', 'WindowPositionD', 'WindowPositionRR', 'HoodOpen', 'AccelLR', 'TurnSignal', 'DoorOpenD', 'Speed', 'AngularVelocity', 'RecIndicator', 'AmbientTemp_A', 'ABSControl', 'SteeringAngle_A', 'PowerModeSelect_B', 'WindowPositionP', 'DoorOpenRR', 'SeatBeltD', 'WhiteLineSymbolL_A', 'WheelSpeedFL', 'FrontBlowerLevel', 'PCSOpStateAlarm', 'DoorLockPositionD', 'TirePressureFR', 'HeadLamp_B', 'LKABuzzer_A', 'SportModeSelect', 'WheelSpeedRL', 'StateOfCharge', 'AccelPedalAngle', 'WhiteLineSymbolR_A', 'TirePressureRL', 'TimeCount', 'TailLampStatus', 'TempSettingP', 'DoorLockPositionP', 'TempSettingD', 'LuggageOpen', 'WheelSpeedFR', 'DoorOpenRL']}, {'title': 'job_type', 'value': 'Un Nested Job'}]",
                    "status": "Error",
                    "requestDateAndTime": "2024-05-02 21:07:51.653732",
                    "processedTime": "1e-05"
                },
                {
                    "id": "6e930f12-4f61-4ebf-bb40-bb4f222d03f8",
                    "job_name": "ManualTest_1",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['AccelLR', 'ABSControl', 'TirePressureFR', 'Speed', 'TirePressureRR', 'TripCount']}, {'title': 'job_type', 'value': 'Un Nested Job'}]",
                    "status": "Error",
                    "requestDateAndTime": "2024-04-30 19:30:07.282353",
                    "processedTime": "446.406938"
                },
                {
                    "id": "0c4ce933-c1ff-4206-a90b-a0c5e75a7a89",
                    "job_name": "ManualTest_1",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['Speed', 'ABSControl', 'TirePressureFR', 'AccelLR', 'AccelFB', 'TripCount']}, {'title': 'job_type', 'value': 'Un-Nested Data'}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-05-21 15:32:36.090508",
                    "processedTime": "2601.339389",
                    "subJobs": [
                        {
                            "id": "2faff1f1-d4a6-40b0-b36e-6a139025c63e",
                            "job_name": null,
                            "user_inputs": "[{'aggregation': [], 'fill_type': 'forward', 'signals': ['ABSControl', 'TirePressureFR', 'AccelLR', 'Speed']}, {'title': 'job_type', 'value': 'Prepared Data'}]",
                            "status": "In Progress",
                            "requestDateAndTime": "2024-05-21 16:12:43.653320",
                            "processedTime": "592962.835171"
                        },
                        {
                            "id": "19b2e1c5-ce36-4130-9f2e-4dd562759964",
                            "job_name": null,
                            "user_inputs": "{'ABSControl': {'max': '5', 'min': '1'}, 'TirePressureFR': {'max': '5', 'min': '1'}, 'Speed': {'max': '150', 'min': '1'}}",
                            "status": "Submitted",
                            "requestDateAndTime": "2024-05-21 16:10:39.423872",
                            "processedTime": "9e-06"
                        }
                    ]
                },
                {
                    "id": "60944086-98eb-4d74-9cd0-2c641b5d3efe",
                    "job_name": "ManualTest_1",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['TRCControl', 'EcoModeInd', 'PowerModeSelect_A', 'HazardSwitch', 'PCSOpStateBrake', 'TripCount']}, {'title': 'job_type', 'value': 'Un Nested Job'}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-04-30 17:16:25.868490",
                    "processedTime": "9948.620765",
                    "subJobs": [
                        {
                            "id": "e3e55529-48c1-41cf-a920-af1e613fb1a9",
                            "job_name": null,
                            "user_inputs": "['EcoModeInd']",
                            "status": "In Progress",
                            "requestDateAndTime": "2024-04-30 19:58:40.291438",
                            "processedTime": "6e-06"
                        },
                        {
                            "id": "296cb4ea-e978-4834-9dc7-19dafc510185",
                            "job_name": null,
                            "user_inputs": "['TRCControl']",
                            "status": "In Progress",
                            "requestDateAndTime": "2024-04-30 19:32:25.129210",
                            "processedTime": "9e-06"
                        },
                        {
                            "id": "f5431f6e-2aa8-4f50-b528-93b6df99da78",
                            "job_name": null,
                            "user_inputs": "['TRCControl']",
                            "status": "In Progress",
                            "requestDateAndTime": "2024-04-30 19:32:47.077963",
                            "processedTime": "9e-06"
                        },
                        {
                            "id": "d4c5c0c5-4bd6-4c43-9907-58ea252242df",
                            "job_name": null,
                            "user_inputs": "['EcoModeInd']",
                            "status": "In Progress",
                            "requestDateAndTime": "2024-04-30 19:58:32.302554",
                            "processedTime": "4e-05"
                        }
                    ]
                },
                {
                    "id": "a94d12f2-0e6f-456e-8759-9d5c1ea2587c",
                    "job_name": "ManualTest_1",
                    "user_inputs": "[{'title': 'vehicleName', 'value': ['MIRAI']}, {'title': 'list_51FLabels', 'value': ['EcoModeInd', 'PowerModeSelect_A', 'HazardSwitch', 'WheelSpeedRR', 'VSCControl', 'TripCount']}, {'title': 'job_type', 'value': 'Un Nested Job'}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-04-30 16:09:25.715066",
                    "processedTime": "723.257995",
                    "subJobs": [
                        {
                            "id": "823a1d4c-7284-410e-aeee-b57903ae080b",
                            "job_name": null,
                            "user_inputs": "['WheelSpeedRR']",
                            "status": "In Progress",
                            "requestDateAndTime": "2024-05-07 14:01:06.297389",
                            "processedTime": "9e-06"
                        }
                    ]
                },
                {
                    "id": "67547de9-49ac-42d0-be36-f088762e0b34",
                    "job_name": "ManualTest_1",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['Speed', 'TripCount']}, {'title': 'ModelYear', 'value': []}, {'title': 'job_type', 'value': 'Un Nested Job'}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-05-07 20:44:51.493405",
                    "processedTime": "387.220652"
                },
                {
                    "id": "63c1d179-187e-43f2-a407-7da8de3b1e8b",
                    "job_name": "ManualTest_1",
                    "user_inputs": "[{'title': 'min_timestamp', 'value': '2024-03-06 06:00:00'}, {'title': 'max_timestamp', 'value': '2024-03-12 05:00:00'}, {'title': 'list_51FLabels', 'value': ['TransmissionType', 'TripCount']}, {'title': 'job_type', 'value': 'Un Nested Job'}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-05-02 18:47:53.645687",
                    "processedTime": "423.275942"
                },
                {
                    "id": "5dd94e95-f1b2-4f21-b054-5373dd9979de",
                    "job_name": "ManualTest_1",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['AccelLR', 'ABSControl', 'TirePressureFR', 'Speed', 'TirePressureRR', 'TripCount']}, {'title': 'job_type', 'value': 'Un Nested Job'}]",
                    "status": "Error",
                    "requestDateAndTime": "2024-05-17 15:43:33.129347",
                    "processedTime": "9e-06"
                },
                {
                    "id": "eb595312-0b83-4381-9f8f-03e4f774236e",
                    "job_name": "ManualTest_1",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['Speed', 'ABSControl', 'AccelFB', 'TirePressureFL', 'TirePressureFR', 'TripCount']}, {'title': 'job_type', 'value': 'Un Nested Job'}]",
                    "status": "Error",
                    "requestDateAndTime": "2024-04-30 19:55:42.759465",
                    "processedTime": "486.562846"
                },
                {
                    "id": "0bf6ad12-e1fb-49d5-9208-e0511bf966c5",
                    "job_name": "ManualTest_1",
                    "user_inputs": "[{'title': 'vins', 'value': ['1ed6afb1-c94a-4b64-a75d-326de5c48486', '9b535908-4358-4e06-93a4-bea0acaf2e50']}, {'title': 'vehicleName', 'value': ['MIRAI']}, {'title': 'ModelYear', 'value': ['2020']}, {'title': 'DispatchModelType', 'value': ['JPD10L-CEDSSA']}, {'title': 'list_CanLabels', 'value': ['024_YRS14S', '620_PCTY']}, {'title': 'list_51FLabels', 'value': ['TirePressureRR', 'Odo', 'TripCount']}, {'title': 'min_timestamp', 'value': '2024-02-06 00:00:00'}, {'title': 'max_timestamp', 'value': '2024-03-14 00:00:00'}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'Test new data'}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-07-24 15:23:17.373191",
                    "processedTime": "586.436729"
                },
                {
                    "id": "89f4d43c-4721-4089-b17f-24863a26f0a4",
                    "job_name": "ManualTest_1",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['Speed', 'ABSControl', 'AccelFB', 'TirePressureFL', 'TirePressureFR', 'TripCount']}, {'title': 'job_type', 'value': 'Un Nested Job'}]",
                    "status": "Error",
                    "requestDateAndTime": "2024-05-02 14:42:23.038112",
                    "processedTime": "1e-05"
                },
                {
                    "id": "105028e8-2894-4765-af8c-938be12970d2",
                    "job_name": "ManualTest_1",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['Speed', 'ABSControl', 'AccelFB', 'TirePressureFL', 'TirePressureFR', 'TripCount']}, {'title': 'job_type', 'value': 'Un Nested Job'}]",
                    "status": "Error",
                    "requestDateAndTime": "2024-04-30 19:55:40.652096",
                    "processedTime": "488.798999",
                    "subJobs": [
                        {
                            "id": "e426beb6-cf4c-4cc4-8144-b37f1da5bd93",
                            "job_name": null,
                            "user_inputs": "['Speed']",
                            "status": "In Progress",
                            "requestDateAndTime": "2024-04-30 22:10:21.138259",
                            "processedTime": "9e-06"
                        },
                        {
                            "id": "17044ac2-b88b-49a5-b57c-9ce29bc333bb",
                            "job_name": null,
                            "user_inputs": "['Speed']",
                            "status": "In Progress",
                            "requestDateAndTime": "2024-04-30 21:55:43.491595",
                            "processedTime": "9e-06"
                        }
                    ]
                },
                {
                    "id": "516148f3-76c6-4fae-9a81-a3fd69ee3009",
                    "job_name": "ManualTest_1",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['Speed', 'AccelLR', 'AccelFB', 'ABSControl', 'TirePressureRL', 'TripCount']}, {'title': 'vins', 'value': ['9b535908-4358-4e06-93a4-bea0acaf2e50', '7093b1fb-7af9-4cc9-b6f0-fab26ca98c0a', '72dbc28e-4ce0-4755-bfa6-709b98a59d8b', '43308702-af40-4ddf-ac92-bc11abb92095', '4eea7c87-9266-452d-bb93-5d7b16bb9b43', 'f7f3c84b-f6bc-4e82-9cb6-58bde6f5a4b5']}, {'title': 'job_type', 'value': 'Un-Nested Data'}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-05-21 18:16:05.606293",
                    "processedTime": "75590.976355",
                    "subJobs": [
                        {
                            "id": "21bf35da-35ef-44c1-95f7-edc7031ad2eb",
                            "job_name": null,
                            "user_inputs": "{}",
                            "status": "Submitted",
                            "requestDateAndTime": "2024-05-22 15:10:41.416598",
                            "processedTime": "1e-05"
                        },
                        {
                            "id": "fd63d38f-7a29-4931-94f8-f88ecda517ff",
                            "job_name": null,
                            "user_inputs": "[{'aggregation': ['min', 'max', 'stddev', 'avg'], 'fill_type': 'forward', 'groupBy': ['By Vin'], 'signals': ['Speed', 'AccelLR', 'AccelFB', 'ABSControl', 'TirePressureRL', 'TripCount']}, {'title': 'job_type', 'value': 'Prepared Data'}]",
                            "status": "Success",
                            "requestDateAndTime": "2024-06-05 02:59:08.644757",
                            "processedTime": "730.174834"
                        }
                    ]
                },
                {
                    "id": "b9fdeaec-ade2-43f1-89de-56a1a46eeb75",
                    "job_name": "ManualTest_1",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['PCSOpStateBrake', 'VSCControl', 'WheelSpeedRR', 'HazardSwitch', 'DoorOpenP', 'PowerModeSelect_A', 'StopLampControl', 'EcoModeInd', 'TransmissionType', 'RearFogLamp', 'TRCControl', 'TirePressureFL', 'LKAAssist_A', 'Odo', 'WindowPositionRL', 'SmartBeamInd', 'BrakePedalInd', 'AccelLR', 'HoodOpen', 'WindowPositionD', 'AccelFB', 'ACInd', 'TripCount', 'DefogInd', 'Speed', 'DoorOpenD', 'TurnSignal']}, {'title': 'job_type', 'value': 'Un Nested Job'}]",
                    "status": "Error",
                    "requestDateAndTime": "2024-05-02 15:47:47.550617",
                    "processedTime": "66257.954555",
                    "subJobs": [
                        {
                            "id": "3b7eb916-84f0-4c85-b6fa-eaa0999c4fa1",
                            "job_name": null,
                            "user_inputs": "{'AccelLR': {'max': '10', 'min': '1'}}",
                            "status": "Submitted",
                            "requestDateAndTime": "2024-05-17 16:32:19.886277",
                            "processedTime": "1e-05"
                        }
                    ]
                }
            ]
        },
        {
            "id": "a7d89fdc-87a2-453b-8ce9-5d293ba9adb3",
            "job_name": "tested",
            "user_inputs": "['7825c75d-579b-4aa8-aa5c-6b11f0e8697e']",
            "status": "Error",
            "requestDateAndTime": "2024-11-11 16:34:05.159121",
            "processedTime": "6e-06"
        },
        {
            "id": "8fc90b9b-36a2-4864-9a10-17f00b22af0e",
            "job_name": "multipemsg",
            "user_inputs": "['2c503f5a-3420-4b32-ba7b-31ab63508ea1', 'bd035272-c0ae-4958-b5d2-845383f1cecb', '80b79d5d-5841-45b9-96f1-4cf8aaa93c3c', '379d6ba3-f564-4098-ba34-2ededd00e59d']",
            "status": "Success",
            "requestDateAndTime": "2024-04-03 05:14:46.035596",
            "processedTime": "212.620805"
        },
        {
            "id": "537f3eef-1156-452b-93cf-bb7c7eb307cf",
            "job_name": "test2",
            "user_inputs": "['05bc5498-9d26-45a5-bfa2-c801c6359a7e']",
            "status": "Success",
            "requestDateAndTime": "2024-04-04 18:59:36.718290",
            "processedTime": "365.298634"
        },
        {
            "id": "81ca0176-4f43-4e2d-afa8-e6de37669d06",
            "job_name": "test",
            "user_inputs": "['fc24d1d9-0b08-4992-b00d-442c1c2d3bf2']",
            "status": "Error",
            "requestDateAndTime": "2024-12-10 19:01:29.186771",
            "processedTime": "9e-06"
        },
        {
            "id": "42f6924b-db7b-4064-ae1c-20e28af2f48a",
            "job_name": "NEWJOBVINS",
            "user_inputs": "['fc24d1d9-0b08-4992-b00d-442c1c2d3bf2', '7825c75d-579b-4aa8-aa5c-6b11f0e8697e', '05bc5498-9d26-45a5-bfa2-c801c6359a7e']",
            "status": "Success",
            "requestDateAndTime": "2024-08-14 15:58:49.167214",
            "processedTime": "973.356717",
            "subJobs": [
                {
                    "id": "a1f9dd1f-1c35-403e-b043-337f6d032e66",
                    "job_name": "NEWJOBVINS",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['WheelSpeedRR', 'Speed', 'WheelSpeedFL', 'WheelSpeedRL', 'WheelSpeedFR', 'AccelFB', 'AccelLR', 'AccelPedalAngle']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'test signals map'}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-08-15 16:59:16.474545",
                    "processedTime": "1310.526078"
                },
                {
                    "id": "c879b341-23ff-4239-a7b0-92e494f37cd1",
                    "job_name": "NEWJOBVINS",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['AccelFB', 'AccelLR', 'AccelPedalAngle', 'Speed', 'WheelSpeedFL', 'WheelSpeedRR', 'WheelSpeedRL', 'WheelSpeedFR', 'TirePressureFL', 'TirePressureRR', 'TirePressureFR', 'TirePressureRL']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'signal test'}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-08-19 19:49:32.253955",
                    "processedTime": "1348.171761",
                    "subJobs": [
                        {
                            "id": "03d51a40-44a5-4d22-b782-ad1056e48d25",
                            "job_name": null,
                            "user_inputs": "[{'fill_signals': ['AccelFB', 'AccelLR', 'AccelPedalAngle', 'Speed', 'WheelSpeedFL', 'WheelSpeedRR', 'WheelSpeedRL', 'WheelSpeedFR', 'TirePressureFL', 'TirePressureRR', 'TirePressureFR', 'TirePressureRL'], 'agg_signals': ['AccelFB', 'AccelLR', 'AccelPedalAngle', 'Speed', 'WheelSpeedFL', 'WheelSpeedRR', 'WheelSpeedRL', 'WheelSpeedFR', 'TirePressureFL', 'TirePressureRR', 'TirePressureFR', 'TirePressureRL'], 'aggregation': ['max'], 'fill_type': 'forward', 'groupBy': ['By Vin']}, {'title': 'job_type', 'value': 'Prepared Data'}]",
                            "status": "Success",
                            "requestDateAndTime": "2024-08-20 16:52:58.878342",
                            "processedTime": "700.742602"
                        }
                    ]
                }
            ]
        },
        {
            "id": "9d60d19c-5bb3-4ba1-96ca-03b167f584c0",
            "job_name": "TestNew1002",
            "user_inputs": "['8b18fbb7-f4f9-4628-bfca-9177553167f9']",
            "status": "Success",
            "requestDateAndTime": "2024-10-02 15:04:02.678479",
            "processedTime": "1499.210004",
            "subJobs": [
                {
                    "id": "7d86519e-ea88-4b51-b2aa-22e181de84cc",
                    "job_name": "TestNew1002",
                    "user_inputs": "['8b18fbb7-f4f9-4628-bfca-9177553167f9']",
                    "status": "Error",
                    "requestDateAndTime": "2025-01-06 20:08:50.960404",
                    "processedTime": "1e-05"
                },
                {
                    "id": "50f1a6e9-f64c-44ce-b8f9-8e48e5066b5f",
                    "job_name": "TestNew1002",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['WheelSpeedFL', 'WheelSpeedRL', 'WheelSpeedFR', 'WheelSpeedRR', 'AccelFB', 'AccelLR', 'AccelPedalAngle', 'Speed', 'EngineRPM']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'Test New1023'}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-10-23 18:23:11.945460",
                    "processedTime": "2089.780617",
                    "subJobs": [
                        {
                            "id": "dbba0619-915d-4f3a-997e-3c21bbcaff6c",
                            "job_name": null,
                            "user_inputs": "[{'agg_signals': ['WheelSpeedFL', 'WheelSpeedRL', 'WheelSpeedFR', 'WheelSpeedRR', 'AccelFB', 'AccelLR', 'Speed', 'EngineRPM'], 'aggregation': ['avg'], 'fill_type': 'noFill', 'groupBy': ['By Vin']}, {'title': 'job_type', 'value': 'Prepared Data'}]",
                            "status": "Success",
                            "requestDateAndTime": "2025-01-17 14:55:12.132067",
                            "processedTime": "438.629668"
                        },
                        {
                            "id": "6e1a9eb7-b7fa-4642-8cbd-5a71d2488e2a",
                            "job_name": null,
                            "user_inputs": "[{'fill_signals': ['WheelSpeedFL', 'WheelSpeedRL', 'AccelLR', 'AccelFB'], 'agg_signals': ['WheelSpeedFL', 'WheelSpeedRL', 'AccelFB', 'AccelLR'], 'aggregation': ['min'], 'fill_type': 'forward', 'groupBy': ['By Vin']}, {'title': 'job_type', 'value': 'Prepared Data'}]",
                            "status": "Success",
                            "requestDateAndTime": "2024-10-31 14:37:52.275109",
                            "processedTime": "600.74978"
                        }
                    ]
                },
                {
                    "id": "a8eeb97b-07c1-4d60-a1ae-4a9b96a33291",
                    "job_name": "TestNew1002",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['WheelSpeedRR', 'Speed', 'WheelSpeedFL', 'WheelSpeedRL', 'WheelSpeedFR', 'AccelFB', 'AccelLR', 'AccelPedalAngle', 'EngineRPM']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'TestNew1002'}]",
                    "status": "Error",
                    "requestDateAndTime": "2024-10-02 20:40:51.782997",
                    "processedTime": "75427.777504",
                    "subJobs": [
                        {
                            "id": "d069ed33-679f-418b-8bc5-324180878e02",
                            "job_name": "TestNew1002",
                            "user_inputs": "[{'title': 'list_51FLabels', 'value': ['WheelSpeedRR', 'Speed', 'WheelSpeedFL', 'WheelSpeedRL', 'WheelSpeedFR', 'AccelFB', 'AccelLR', 'AccelPedalAngle', 'EngineRPM']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'TestNew1002'}]",
                            "status": "Error",
                            "requestDateAndTime": "2025-01-17 15:07:03.725576",
                            "processedTime": "1e-05"
                        },
                        {
                            "id": "32c50d99-b2eb-46a6-ad6c-6334b92d7c70",
                            "job_name": null,
                            "user_inputs": "[{'title': 'list_51FLabels', 'value': ['WheelSpeedRR', 'Speed', 'WheelSpeedFL', 'WheelSpeedRL', 'WheelSpeedFR', 'AccelFB', 'AccelLR', 'AccelPedalAngle', 'EngineRPM']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'TestNew1002'}]",
                            "status": "In Progress",
                            "requestDateAndTime": "2025-01-17 15:07:52.328558",
                            "processedTime": "9e-06"
                        },
                        {
                            "id": "d568c7e8-221a-4f17-b815-f78fd9bf76aa",
                            "job_name": "TestNew1002",
                            "user_inputs": "[{'title': 'list_51FLabels', 'value': ['WheelSpeedRR', 'Speed', 'WheelSpeedFL', 'WheelSpeedRL', 'WheelSpeedFR', 'AccelFB', 'AccelLR', 'AccelPedalAngle', 'EngineRPM']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'TestNew1002'}]",
                            "status": "Error",
                            "requestDateAndTime": "2025-01-17 14:48:41.630666",
                            "processedTime": "8e-06"
                        },
                        {
                            "id": "f58cceaa-e929-4e5b-b37a-ead5ef0ed63c",
                            "job_name": "TestNew1002",
                            "user_inputs": "[{'title': 'list_51FLabels', 'value': ['WheelSpeedRR', 'Speed', 'WheelSpeedFL', 'WheelSpeedRL', 'WheelSpeedFR', 'AccelFB', 'AccelLR', 'AccelPedalAngle', 'EngineRPM']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'TestNew1002'}]",
                            "status": "Error",
                            "requestDateAndTime": "2025-01-17 14:42:09.632040",
                            "processedTime": "9e-06"
                        },
                        {
                            "id": "b4b74a79-05a0-4c7d-b101-18864ce9163a",
                            "job_name": "TestNew1002",
                            "user_inputs": "[{'title': 'list_51FLabels', 'value': ['WheelSpeedRR', 'Speed', 'WheelSpeedFL', 'WheelSpeedRL', 'WheelSpeedFR', 'AccelFB', 'AccelLR', 'AccelPedalAngle', 'EngineRPM']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'TestNew1002'}]",
                            "status": "Error",
                            "requestDateAndTime": "2025-01-17 15:07:30.177491",
                            "processedTime": "9e-06"
                        },
                        {
                            "id": "02d1dfcd-6934-49a0-8091-cdd52213e87e",
                            "job_name": null,
                            "user_inputs": "[{'title': 'list_51FLabels', 'value': ['WheelSpeedRR', 'Speed', 'WheelSpeedFL', 'WheelSpeedRL', 'WheelSpeedFR', 'AccelFB', 'AccelLR', 'AccelPedalAngle', 'EngineRPM']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'TestNew1002'}]",
                            "status": "In Progress",
                            "requestDateAndTime": "2025-01-17 15:02:56.598320",
                            "processedTime": "1e-05"
                        },
                        {
                            "id": "dd31bbe7-c358-437b-9332-f31b2fb70463",
                            "job_name": null,
                            "user_inputs": "[{'fill_signals': ['WheelSpeedRR', 'Speed', 'WheelSpeedFL', 'EngineRPM'], 'aggregation': [], 'fill_type': 'forward', 'groupBy': []}, {'title': 'job_type', 'value': 'Prepared Data'}]",
                            "status": "Success",
                            "requestDateAndTime": "2024-10-02 22:27:26.067004",
                            "processedTime": "130194.345188"
                        }
                    ]
                },
                {
                    "id": "80861798-1cb6-4f08-bc92-b03eb9bcca16",
                    "job_name": "TestNew1002",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['ACInd', 'BrakePedalInd', 'BrakePedalPressure', 'Speed', 'WheelSpeedRR', 'EngineRPM']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'testNAN'}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-10-25 16:44:57.042484",
                    "processedTime": "1498.55203",
                    "subJobs": [
                        {
                            "id": "076dfa6b-4ce1-4c42-9a85-10c3955ad49b",
                            "job_name": null,
                            "user_inputs": "[{'fill_signals': ['Speed', 'EngineRPM', 'WheelSpeedRR'], 'aggregation': [], 'fill_type': 'forward', 'groupBy': []}, {'title': 'job_type', 'value': 'Prepared Data'}]",
                            "status": "Success",
                            "requestDateAndTime": "2024-10-25 21:36:31.168183",
                            "processedTime": "567.027589"
                        }
                    ]
                },
                {
                    "id": "d9e2292e-ab36-4187-8177-8a033b7dd809",
                    "job_name": "TestNew1002",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['ABSControl', 'ACInd', 'ACStatus', 'ATShiftPosition', 'BrakePedalPressure', 'BrakeTorque', 'BrakeWheelPressure']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'unnest jan 17'}]",
                    "status": "Error",
                    "requestDateAndTime": "2025-01-17 14:43:04.245491",
                    "processedTime": "8e-06"
                },
                {
                    "id": "cc532b27-724c-4835-92e6-04be4f77fec2",
                    "job_name": "TestNew1002",
                    "user_inputs": "['8b18fbb7-f4f9-4628-bfca-9177553167f9']",
                    "status": "Error",
                    "requestDateAndTime": "2025-01-17 14:34:23.443947",
                    "processedTime": "9e-06"
                },
                {
                    "id": "ff8b7fbd-eaaa-411e-a04f-b09d47e668cd",
                    "job_name": "TestNew1002",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['WheelSpeedRR', 'Speed', 'WheelSpeedFL', 'WheelSpeedRL', 'WheelSpeedFR', 'AccelFB', 'AccelLR', 'AccelPedalAngle', 'EngineRPM']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'TestNew1002'}]",
                    "status": "Error",
                    "requestDateAndTime": "2024-10-21 14:36:39.605645",
                    "processedTime": "8e-06"
                },
                {
                    "id": "53ea70e3-b9e0-487c-a38a-c08d822dc896",
                    "job_name": "TestNew1002",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['WheelSpeedRR', 'Speed', 'WheelSpeedFL', 'WheelSpeedRL', 'WheelSpeedFR', 'AccelFB', 'AccelLR', 'AccelPedalAngle', 'EngineRPM']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'TestNew1002'}]",
                    "status": "Error",
                    "requestDateAndTime": "2024-10-21 20:19:34.810203",
                    "processedTime": "9e-06"
                }
            ]
        },
        {
            "id": "3557d312-130e-4300-bc59-b8b3e4a95e8e",
            "job_name": "testman1001",
            "user_inputs": "['fc24d1d9-0b08-4992-b00d-442c1c2d3bf2', '7825c75d-579b-4aa8-aa5c-6b11f0e8697e']",
            "status": "Error",
            "requestDateAndTime": "2024-10-01 13:51:41.363974",
            "processedTime": "6e-06"
        },
        {
            "id": "071bcf98-382a-4097-a7d8-6d37f0f1a267",
            "job_name": "test5",
            "user_inputs": "['05bc5498-9d26-45a5-bfa2-c801c6359a7e']",
            "status": "Success",
            "requestDateAndTime": "2024-07-26 15:49:07.476355",
            "processedTime": "615.637596",
            "subJobs": [
                {
                    "id": "0ad6d9b7-88a0-4bdf-a4f7-a29986e556df",
                    "job_name": "test5",
                    "user_inputs": "[{'title': 'vins', 'value': ['1ed6afb1-c94a-4b64-a75d-326de5c48486']}, {'title': 'list_51FLabels', 'value': ['Speed', 'WheelSpeedFL', 'WheelSpeedRL', 'WheelSpeedFR', 'WheelSpeedRR', 'AccelFB', 'AccelLR', 'TripCount']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'test new'}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-08-05 13:58:32.939668",
                    "processedTime": "546.386524"
                }
            ]
        },
        {
            "id": "53e1fa99-1277-4f48-89cf-d5441cde41d9",
            "job_name": "test1",
            "user_inputs": "['baccc108-fb53-4467-8070-d86dda515406']",
            "status": "Success",
            "requestDateAndTime": "2024-12-26 17:15:46.887824",
            "processedTime": "648.65912"
        },
        {
            "id": "d752e302-55ba-4234-8549-691741df92a2",
            "job_name": "Teste",
            "user_inputs": "['379d6ba3-f564-4098-ba34-2ededd00e59d', '2c503f5a-3420-4b32-ba7b-31ab63508ea1', '80b79d5d-5841-45b9-96f1-4cf8aaa93c3c', 'bd035272-c0ae-4958-b5d2-845383f1cecb']",
            "status": "Success",
            "requestDateAndTime": "2024-05-29 21:40:53.667580",
            "processedTime": "435.585658",
            "subJobs": [
                {
                    "id": "95772623-9e47-4a1c-b5b6-0ba567d9eb34",
                    "job_name": "Teste",
                    "user_inputs": "[{'title': 'vins', 'value': ['1ae94dbf-8ccf-4356-a957-8def4972deb5', 'a4d37798-c9de-40d4-ae06-9bd64557acfa']}, {'title': 'list_51FLabels', 'value': ['Speed', 'TripCount']}, {'title': 'job_type', 'value': 'Un-Nested Data'}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-06-21 20:22:03.167937",
                    "processedTime": "534.018272"
                },
                {
                    "id": "00c798d8-ce4d-4d5e-98c5-7c3e662e2efb",
                    "job_name": "Teste",
                    "user_inputs": "[{'title': 'ModelYear', 'value': ['2020', '2021']}, {'title': 'list_51FLabels', 'value': ['VSCControl', 'PCSOpStateBrake', 'TripCount']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'Test Modal Year'}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-07-01 16:35:20.550685",
                    "processedTime": "467.806806"
                }
            ]
        },
        {
            "id": "c6dafd48-178c-41fc-8db2-c9c42ad3f246",
            "job_name": "test4",
            "user_inputs": "['05bc5498-9d26-45a5-bfa2-c801c6359a7e']",
            "status": "Success",
            "requestDateAndTime": "2024-07-26 15:48:13.030335",
            "processedTime": "622.114963"
        },
        {
            "id": "94875359-5e1d-4517-8d37-4c43f26c8fe9",
            "job_name": "test8",
            "user_inputs": "['05bc5498-9d26-45a5-bfa2-c801c6359a7e']",
            "status": "Success",
            "requestDateAndTime": "2024-04-04 22:26:20.831902",
            "processedTime": "342.360974",
            "subJobs": [
                {
                    "id": "3c9a6e29-097c-465e-ac8b-8c391f89e8c8",
                    "job_name": "test8",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['TirePressureRL', 'WheelSpeedFR', 'TirePressureFR', 'WheelSpeedFL', 'Speed', 'ABSControl', 'TripCount']}, {'title': 'job_type', 'value': 'Un Nested Job'}]",
                    "status": "Error",
                    "requestDateAndTime": "2024-05-02 16:42:00.416840",
                    "processedTime": "527.269645",
                    "subJobs": [
                        {
                            "id": "6245da66-c7da-4ccd-8b0b-1084b05dc6b7",
                            "job_name": null,
                            "user_inputs": "['Speed']",
                            "status": "In Progress",
                            "requestDateAndTime": "2024-05-08 15:14:37.590226",
                            "processedTime": "1e-05"
                        },
                        {
                            "id": "6e178430-615e-4c2e-9307-dfb38ddd3d7a",
                            "job_name": null,
                            "user_inputs": "{'Speed': {'max': '150', 'min': '0'}}",
                            "status": "Submitted",
                            "requestDateAndTime": "2024-05-08 15:13:53.134497",
                            "processedTime": "9e-06"
                        },
                        {
                            "id": "b7f42edf-383b-4fda-9aa5-01a7eacf483b",
                            "job_name": null,
                            "user_inputs": "[{'aggregation': ['Max', 'Min', 'Avg', 'Std Deviation', 'Quartiles', 'Discrete State of Time', 'Discrete Variables', '% input', 'Discrete State (as a %)'], 'signals': ['Speed'], 'fill_type': 'forward', 'groupBy': ['By VIN']}]",
                            "status": "In Progress",
                            "requestDateAndTime": "2024-05-08 15:24:29.427179",
                            "processedTime": "1.2e-05"
                        }
                    ]
                },
                {
                    "id": "7b014b50-391a-4d0e-ae65-7919002c64c7",
                    "job_name": "testnew",
                    "user_inputs": "[{'title': 'list_CanLabels', 'value': ['024_YRS14S', '622_SB_IND']}, {'title': 'list_51FLabels', 'value': ['Odo', 'RearDefInd']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'test vin file uploads'}]",
                    "status": "Error",
                    "requestDateAndTime": "2024-08-14 12:44:50.456713",
                    "processedTime": "9e-06"
                }
            ]
        },
        {
            "id": "c95f6003-2ebd-4d43-b15c-96be779e4c3f",
            "job_name": "testvvv",
            "user_inputs": "['38e715ed-2144-4218-99c5-baba1a715ef8']",
            "status": "Error",
            "requestDateAndTime": "2024-11-11 16:33:48.996826",
            "processedTime": "6e-06"
        },
        {
            "id": "9c13e1cc-c005-4cb6-b87b-4542a7763198",
            "job_name": "test1",
            "user_inputs": "['baccc108-fb53-4467-8070-d86dda515406']",
            "status": "Success",
            "requestDateAndTime": "2024-12-16 22:35:41.792139",
            "processedTime": "669.784798"
        },
        {
            "id": "29db8857-a0b5-4241-86e7-d8b653d2d1c8",
            "job_name": "newtest",
            "user_inputs": "['3d20e6fe-f09e-444a-8d10-32217d042c73']",
            "status": "Error",
            "requestDateAndTime": "2024-11-11 16:30:23.487149",
            "processedTime": "1e-05"
        },
        {
            "id": "d05a8bb2-c1fd-43e6-9ef6-704cb14bde18",
            "job_name": "testfeb13",
            "user_inputs": "['5965a84d-3a8d-44b0-b70a-9d23838fd8c3']",
            "status": "Success",
            "requestDateAndTime": "2025-02-13 17:04:19.168762",
            "processedTime": "894.464079",
            "subJobs": [
                {
                    "id": "dd58d559-11e6-403c-9299-e6f4122597e6",
                    "job_name": "testfeb13",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['Speed', 'WheelSpeedFL', 'WheelSpeedFR', 'AccelFB', 'AccelLR']}, {'title': 'list_CanLabels', 'value': ['116_EACCP', '381_I_REC']}, {'title': 'odometer', 'value': {'minValue': '7268', 'maxValue': '7325'}}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'test Feb 13 new'}]",
                    "status": "Success",
                    "requestDateAndTime": "2025-02-13 17:46:55.660863",
                    "processedTime": "683.061174",
                    "subJobs": [
                        {
                            "id": "4ef1faa6-b27a-457a-a02a-cbe1e3d89c66",
                            "job_name": null,
                            "user_inputs": "[{'fill_signals': ['116_EACCP', '381_I_REC', 'Speed', 'AccelFB', 'AccelLR'], 'agg_signals': ['116_EACCP', '381_I_REC', 'Speed', 'AccelFB', 'AccelLR'], 'aggregation': ['max', 'min', 'avg', 'discrete_state_of_time', 'discrete_variables'], 'fill_type': 'forward', 'groupBy': ['By Vin']}, {'title': 'job_type', 'value': 'Prepared Data'}]",
                            "status": "Success",
                            "requestDateAndTime": "2025-02-13 19:18:11.063004",
                            "processedTime": "392.418229"
                        }
                    ]
                }
            ]
        },
        {
            "id": "34d62539-6e2c-4061-80b4-f9de7aa7c695",
            "job_name": "ManualTCID",
            "user_inputs": "['d541c8b9-3796-4b40-9a94-7007d814a9f0']",
            "status": "Success",
            "requestDateAndTime": "2024-04-03 03:51:27.052469",
            "processedTime": "298.740751",
            "subJobs": [
                {
                    "id": "6b21ac54-8ff1-457d-a5e1-c7ab2332f449",
                    "job_name": "ManualTCID",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['Speed', 'ABSControl', 'AccelFB', 'AccelLR', 'TirePressureFR_TypeB', 'TirePressureRL_TypeB', 'TirePressureRR_TypeB', 'TirePressureSP_TypeB', 'TirePressureFL_TypeB', 'TripCount']}, {'title': 'job_type', 'value': 'Un-Nested Data'}]",
                    "status": "Error",
                    "requestDateAndTime": "2024-06-04 14:08:48.721950",
                    "processedTime": "413.828111"
                }
            ]
        },
        {
            "id": "eab3f0d4-3f14-4de1-bb7b-d1274668db1a",
            "job_name": "test7",
            "user_inputs": "['8b18fbb7-f4f9-4628-bfca-9177553167f9', 'f271b986-524d-43da-ac69-80f35aa9060e']",
            "status": "Error",
            "requestDateAndTime": "2024-07-26 15:57:24.360783",
            "processedTime": "7852097.845897",
            "subJobs": [
                {
                    "id": "c8b283d4-8665-4b79-909a-bf558dfe5daa",
                    "job_name": "test7",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['WheelSpeedRR', 'Speed', 'WheelSpeedFL', 'WheelSpeedRL', 'WheelSpeedFR', 'AccelPedalAngleExControl', 'AccelFB', 'AccelLR', 'AccelPedalAngle', 'TirePressureFR_TypeB', 'TirePressureRL_TypeB', 'TirePressureRR_TypeB']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'fault data for new test'}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-09-24 14:04:49.216751",
                    "processedTime": "8230.366405"
                },
                {
                    "id": "4cb0d186-bba7-431a-8f0a-9b8383576c75",
                    "job_name": "test7",
                    "user_inputs": "[{'title': 'vins', 'value': ['9b535908-4358-4e06-93a4-bea0acaf2e50', '1ed6afb1-c94a-4b64-a75d-326de5c48486', '7093b1fb-7af9-4cc9-b6f0-fab26ca98c0a', '72dbc28e-4ce0-4755-bfa6-709b98a59d8b', 'f6dd2486-6017-4052-b2b7-961f5adfe9a2']}, {'title': 'list_51FLabels', 'value': ['Speed', 'WheelSpeedRL', 'WheelSpeedFL', 'WheelSpeedFR', 'WheelSpeedRR']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'test location filters'}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-08-12 13:28:05.429063",
                    "processedTime": "2398679.770489"
                },
                {
                    "id": "b68857af-d615-473e-b1ca-3537d8f5b228",
                    "job_name": "test7",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['AccelFB', 'WheelSpeedRR', 'Speed', 'WheelSpeedFL', 'WheelSpeedRL', 'DoorLockPositionRL', 'DoorOpenP', 'DoorLockPositionRR', 'DoorOpenD', 'DoorOpenRR', 'DoorLockPositionD']}, {'title': 'latitudes', 'value': ['46.991494313050424', '39.257778150283364', '30.021543509740027', '36.48314061639213']}, {'title': 'longitudes', 'value': ['-119.42153489517263', '-79.58861399979972', '-98.22060492755558', '-119.31294651799428']}, {'title': 'Type', 'value': 'in_bond'}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'test big data'}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-08-13 19:31:05.084528",
                    "processedTime": "818.54618",
                    "subJobs": [
                        {
                            "id": "0e840b7f-7317-444e-aa13-1b100c19131f",
                            "job_name": null,
                            "user_inputs": "[{'fill_signals': ['Speed', 'AccelLR', 'TirePressureFR'], 'agg_signals': ['Speed', 'TirePressureFR', 'WheelSpeedFR', 'AccelLR'], 'aggregation': ['max', 'avg', 'min'], 'fill_type': 'forward', 'groupBy': ['By Vin', 'By DispatchModelType']}, {'title': 'job_type', 'value': 'Prepared Data'}]",
                            "status": "Success",
                            "requestDateAndTime": "2024-08-19 13:15:00.273253",
                            "processedTime": "434.83882"
                        }
                    ]
                },
                {
                    "id": "c50963f8-f9e4-41a4-80c1-fe49d40dcad8",
                    "job_name": "test7",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['WheelSpeedRR', 'TripCount']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'testtrip'}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-08-07 17:39:46.811171",
                    "processedTime": "666.357429"
                },
                {
                    "id": "7e265345-71d0-4ce2-b077-f477e9ef318c",
                    "job_name": "test7",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['Speed']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'test2notripcountsignal'}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-08-08 17:29:04.769859",
                    "processedTime": "646.949591"
                },
                {
                    "id": "6b938709-b590-418d-a78a-c58b58445380",
                    "job_name": "test7",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['TPMonitoringStateFR']}, {'title': 'latitudes', 'value': ['33.00009786293862', '32.99765038685102', '32.997542408401145', '33.00018784238325']}, {'title': 'longitudes', 'value': ['-96.78753491280925', '-96.78948690681072', '-96.79281166849869', '-96.79216836972802']}, {'title': 'Type', 'value': 'in_bond'}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'trtdt'}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-09-10 21:28:47.760956",
                    "processedTime": "3648.634102"
                },
                {
                    "id": "40426e25-aa12-422c-ac8e-729a333a807c",
                    "job_name": "test7",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['WheelSpeedRR', 'WheelSpeedFL', 'WheelSpeedRL', 'WheelSpeedFR', 'AccelFB', 'AccelPedalAngleExControl', 'AccelLR', 'AccelPedalAngle', 'Speed', 'TirePressureFR_TypeB', 'TirePressureRL_TypeB']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'test new'}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-09-24 13:42:03.451970",
                    "processedTime": "9478.196595"
                },
                {
                    "id": "9b904f6f-5e99-473e-908f-d533e4bcf250",
                    "job_name": "test7",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['Speed', 'TripCount']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'testtripcountnotavailable'}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-08-08 16:37:11.884818",
                    "processedTime": "704.397579"
                }
            ]
        },
        {
            "id": "e96cc411-c3b3-4697-a38a-38e335cde86d",
            "job_name": "testneeeee",
            "user_inputs": "['423aee43-dc6c-4ba6-9d5e-b55727ea693a']",
            "status": "Error",
            "requestDateAndTime": "2024-11-21 16:15:41.266949",
            "processedTime": "7e-06"
        },
        {
            "id": "935ca314-a785-4b26-b208-10e41418e8f5",
            "job_name": "test5",
            "user_inputs": "['05bc5498-9d26-45a5-bfa2-c801c6359a7e']",
            "status": "Success",
            "requestDateAndTime": "2024-04-04 22:25:43.319671",
            "processedTime": "332.452103"
        },
        {
            "id": "61a2c0b3-9c35-41c3-b84c-894c45c9d879",
            "job_name": "CSVTEST",
            "user_inputs": "['05bc5498-9d26-45a5-bfa2-c801c6359a7e']",
            "status": "Success",
            "requestDateAndTime": "2024-03-29 13:12:54.330427",
            "processedTime": "364.827744",
            "subJobs": [
                {
                    "id": "c04a4818-21a8-4033-99e9-dfb561daa61b",
                    "job_name": "CSVTEST",
                    "user_inputs": "[{'title': 'list_CanLabels', 'value': ['3B7_B_HZD', '0AA_VXFR', '622_HEDH']}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-04-01 15:04:40.005185",
                    "processedTime": "516.695923"
                },
                {
                    "id": "a26f6f04-8e2a-4708-89c9-d891b88a8acb",
                    "job_name": "CSVTEST",
                    "user_inputs": "[{'title': 'vins', 'value': ['f6dd2486-6017-4052-b2b7-961f5adfe9a2', '43308702-af40-4ddf-ac92-bc11abb92095', '4eea7c87-9266-452d-bb93-5d7b16bb9b43']}]",
                    "status": "Error",
                    "requestDateAndTime": "2024-03-29 18:42:54.621085",
                    "processedTime": "1e-05"
                },
                {
                    "id": "9465c4f9-ea23-4b5e-9e20-92c4573c7dc5",
                    "job_name": "CSVTEST",
                    "user_inputs": "[{'title': 'vehicleName', 'value': ['MIRAI']}, {'title': 'ModelYear', 'value': ['2019']}, {'title': 'DispatchModelType', 'value': ['JPD10L-CEDSSA']}, {'title': 'list_51FLabels', 'value': ['RearFogLamp']}, {'title': 'vins', 'value': ['72dbc28e-4ce0-4755-bfa6-709b98a59d8b']}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-04-03 04:31:51.548655",
                    "processedTime": "348.441519"
                },
                {
                    "id": "7d74b30e-04cf-45cf-acd6-01b77df76ab0",
                    "job_name": "CSVTEST",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['TransmissionType', 'PowerModeSelect_A', 'PCSOpStateBrake', 'TirePressureFL']}, {'title': 'vehicleName', 'value': ['MIRAI']}, {'title': 'ModelYear', 'value': ['2019']}, {'title': 'DispatchModelType', 'value': ['JPD10L-CEDSSA']}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-03-29 13:33:21.551780",
                    "processedTime": "348.197201"
                }
            ]
        },
        {
            "id": "11f5d471-0fe0-452a-809b-cd378794842a",
            "job_name": "testneeeee",
            "user_inputs": "['423aee43-dc6c-4ba6-9d5e-b55727ea693a']",
            "status": "Error",
            "requestDateAndTime": "2024-12-10 18:50:57.091926",
            "processedTime": "1.2e-05"
        },
        {
            "id": "565c4203-ce78-454f-87bc-98140e7a0823",
            "job_name": "test2",
            "user_inputs": "['05bc5498-9d26-45a5-bfa2-c801c6359a7e']",
            "status": "Success",
            "requestDateAndTime": "2024-07-26 15:44:21.410071",
            "processedTime": "531.329575"
        },
        {
            "id": "95422fe4-0b0b-4168-a9d6-63bfe65740dc",
            "job_name": "test4",
            "user_inputs": "['05bc5498-9d26-45a5-bfa2-c801c6359a7e']",
            "status": "Success",
            "requestDateAndTime": "2024-04-04 22:26:51.667253",
            "processedTime": "395.489621",
            "subJobs": [
                {
                    "id": "cab14277-ad46-4082-84a1-6cfaaf680f41",
                    "job_name": "test4",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['EcoModeInd']}, {'title': 'min_timestamp', 'value': '2024-03-20 05:00:00'}]",
                    "status": "Error",
                    "requestDateAndTime": "2024-04-05 16:31:31.484866",
                    "processedTime": "1e-05"
                },
                {
                    "id": "457513bd-7dda-41c8-98d3-75e3de15484b",
                    "job_name": "test4",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['HazardSwitch', 'TripCount']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'test file upload vin'}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-07-24 15:26:21.609156",
                    "processedTime": "575.566872"
                }
            ]
        },
        {
            "id": "fbd6d2d3-a116-49c1-8b57-2bf7139cb41a",
            "job_name": "newjobnov25",
            "user_inputs": "['baccc108-fb53-4467-8070-d86dda515406']",
            "status": "Success",
            "requestDateAndTime": "2024-11-25 17:36:29.252586",
            "processedTime": "621.925756"
        },
        {
            "id": "fb9e94c9-9441-4d78-ad6c-155e3ac0f698",
            "job_name": "testff",
            "user_inputs": "['1dbf012c-2860-49a0-84eb-accc683bdfae']",
            "status": "Error",
            "requestDateAndTime": "2024-11-11 16:33:23.200589",
            "processedTime": "5e-06"
        },
        {
            "id": "c815faa7-c2fe-4a38-a15e-d4801bf3b963",
            "job_name": "jan16",
            "user_inputs": "['baccc108-fb53-4467-8070-d86dda515406']",
            "status": "Success",
            "requestDateAndTime": "2025-01-16 14:39:17.595285",
            "processedTime": "626.625878"
        },
        {
            "id": "d53657a3-289b-4fe6-897b-7f5d296159e1",
            "job_name": "jan17test",
            "user_inputs": "['baccc108-fb53-4467-8070-d86dda515406']",
            "status": "Success",
            "requestDateAndTime": "2025-01-17 14:29:15.127477",
            "processedTime": "497.528593"
        },
        {
            "id": "13532820-209d-4723-afb5-9a39057bb9c7",
            "job_name": "test",
            "user_inputs": "['fc24d1d9-0b08-4992-b00d-442c1c2d3bf2']",
            "status": "Error",
            "requestDateAndTime": "2025-01-17 14:33:31.036501",
            "processedTime": "5e-06"
        },
        {
            "id": "be80fa3e-0a91-46ed-8071-6b01d25bea99",
            "job_name": "mmsg",
            "user_inputs": "['2c503f5a-3420-4b32-ba7b-31ab63508ea1', 'bd035272-c0ae-4958-b5d2-845383f1cecb', '80b79d5d-5841-45b9-96f1-4cf8aaa93c3c', '379d6ba3-f564-4098-ba34-2ededd00e59d']",
            "status": "Success",
            "requestDateAndTime": "2024-04-03 05:15:29.229771",
            "processedTime": "303.764239",
            "subJobs": [
                {
                    "id": "a08f6793-71d8-4485-8a9a-d72bcdf6ba5e",
                    "job_name": "mmsg",
                    "user_inputs": "[{'title': 'ModelYear', 'value': ['2021']}, {'title': 'list_CanLabels', 'value': ['0AA_VXFR', '61F_EV_ODO']}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-04-03 05:28:42.156013",
                    "processedTime": "338.299643"
                }
            ]
        },
        {
            "id": "1c3a56c3-eeb4-4e2f-8eae-f686616e22a1",
            "job_name": "EMLTEST",
            "user_inputs": "['05bc5498-9d26-45a5-bfa2-c801c6359a7e']",
            "status": "Success",
            "requestDateAndTime": "2024-03-29 13:17:11.864492",
            "processedTime": "395.562764",
            "subJobs": [
                {
                    "id": "8cef8612-db52-476c-b65f-8c18c68641d9",
                    "job_name": "EMLTEST",
                    "user_inputs": "[{'title': 'vins', 'value': ['9b535908-4358-4e06-93a4-bea0acaf2e50', '72dbc28e-4ce0-4755-bfa6-709b98a59d8b']}, {'title': 'list_CanLabels', 'value': ['420_GL2Z', '3BC_B_R', '0AA_VXRR', '622_HEDH']}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-03-29 15:02:30.422765",
                    "processedTime": "386.372328"
                }
            ]
        },
        {
            "id": "afc33337-fbac-4a5a-a9b7-8920e0fea1c4",
            "job_name": "testere",
            "user_inputs": "['63881929-47fc-4588-9d58-1cbb8d9cdd3e']",
            "status": "Error",
            "requestDateAndTime": "2024-11-11 16:34:17.593762",
            "processedTime": "7e-06"
        },
        {
            "id": "d2490c4c-be2a-4901-853e-13bab3446d47",
            "job_name": "test6",
            "user_inputs": "['05bc5498-9d26-45a5-bfa2-c801c6359a7e']",
            "status": "Success",
            "requestDateAndTime": "2024-04-04 22:25:55.460121",
            "processedTime": "520.905326",
            "subJobs": [
                {
                    "id": "0575be2b-c9e5-485e-bb80-455a1f7ebdf9",
                    "job_name": "test6",
                    "user_inputs": "[{'title': 'list_CanLabels', 'value': ['6E2_TPM_FRPR', '412_LKAMDT', '383_SL_ACDSP', '638_LSWP', '6E2_TPM_RLPR', '3BC_B_ECOMI']}, {'title': 'list_51FLabels', 'value': ['TurnSignal', 'ABSControl', 'TirePressureRL', 'TirePressureFR', 'WheelSpeedFR', 'AccelLR', 'TripCount']}, {'title': 'ModelYear', 'value': ['2018']}, {'title': 'job_type', 'value': 'Un Nested Job'}]",
                    "status": "Error",
                    "requestDateAndTime": "2024-05-02 16:47:54.769211",
                    "processedTime": "553.124332",
                    "subJobs": [
                        {
                            "id": "d4678889-7a24-46a3-ab03-ce213597d150",
                            "job_name": null,
                            "user_inputs": "['ABSControl']",
                            "status": "In Progress",
                            "requestDateAndTime": "2024-05-07 21:39:27.936468",
                            "processedTime": "9e-06"
                        },
                        {
                            "id": "a23a7633-7b3b-49d8-a4ae-408b35b7884d",
                            "job_name": null,
                            "user_inputs": "[]",
                            "status": "In Progress",
                            "requestDateAndTime": "2024-05-08 14:41:24.515861",
                            "processedTime": "9e-06"
                        },
                        {
                            "id": "0d3ea8b3-bbee-4adb-a821-d2a8b2d1d728",
                            "job_name": null,
                            "user_inputs": "['ABSControl', 'WheelSpeedFR', 'AccelLR', 'TirePressureRL']",
                            "status": "In Progress",
                            "requestDateAndTime": "2024-05-07 21:04:29.409236",
                            "processedTime": "9e-06"
                        },
                        {
                            "id": "bdfe51ee-ecf3-4d07-b5a8-cacf6465493b",
                            "job_name": null,
                            "user_inputs": "{'WheelSpeedFR': {'max': '150', 'min': '0'}}",
                            "status": "Submitted",
                            "requestDateAndTime": "2024-05-08 14:38:41.237943",
                            "processedTime": "1e-05"
                        },
                        {
                            "id": "3d50ced2-bac1-4183-b5e0-79b5a92c13c5",
                            "job_name": null,
                            "user_inputs": "['ABSControl', 'WheelSpeedFR', 'TirePressureFR', 'TirePressureRL']",
                            "status": "In Progress",
                            "requestDateAndTime": "2024-05-07 21:18:46.096640",
                            "processedTime": "9e-06"
                        },
                        {
                            "id": "64fbbb0a-848a-4781-9a88-bd0d93e61fcd",
                            "job_name": null,
                            "user_inputs": "['TirePressureRL', 'ABSControl']",
                            "status": "In Progress",
                            "requestDateAndTime": "2024-05-08 14:42:13.916042",
                            "processedTime": "9e-06"
                        }
                    ]
                },
                {
                    "id": "65f8251d-1dfb-418a-a5f1-4e0eb46abce3",
                    "job_name": "test6",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['Speed', 'TripCount']}, {'title': 'latitudes', 'value': ['41.166249339092', '41.16575426089384', '21.682952865478285', '41.430371882652814']}, {'title': 'longitudes', 'value': ['-90.98465999565724', '-90.98457245344916', '-97.31919739794444', '-99.07619562463812']}, {'title': 'Type', 'value': 'in_bond'}, {'title': 'job_type', 'value': 'Un Nested Job'}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-05-08 20:03:08.198246",
                    "processedTime": "657.831865"
                }
            ]
        },
        {
            "id": "2cdacd8d-fb0e-46cf-9a97-901aac01e142",
            "job_name": "test3",
            "user_inputs": "['05bc5498-9d26-45a5-bfa2-c801c6359a7e']",
            "status": "Success",
            "requestDateAndTime": "2024-07-26 15:46:02.488534",
            "processedTime": "588.665768"
        },
        {
            "id": "8c57a8ff-6a71-4b6e-a6b5-d9dc2a767dc4",
            "job_name": "testmultiple",
            "user_inputs": "['05bc5498-9d26-45a5-bfa2-c801c6359a7e']",
            "status": "Success",
            "requestDateAndTime": "2024-04-03 04:57:21.259882",
            "processedTime": "363.224684"
        },
        {
            "id": "787a6016-2d88-47fd-8fac-d54bc250df5f",
            "job_name": "Testingnew",
            "user_inputs": "[]",
            "status": "Error",
            "requestDateAndTime": "2024-05-29 14:50:41.498696",
            "processedTime": "7e-06"
        },
        {
            "id": "7ae7e945-5000-4584-baa9-a95a091712e1",
            "job_name": "testqa",
            "user_inputs": "['8b18fbb7-f4f9-4628-bfca-9177553167f9']",
            "status": "Success",
            "requestDateAndTime": "2024-09-24 19:05:00.614725",
            "processedTime": "1231.999721",
            "subJobs": [
                {
                    "id": "231e06b2-4c25-4af9-a9ef-586369bb3914",
                    "job_name": "testqa",
                    "user_inputs": "[{'title': 'vins', 'value': ['d1253a7a-f09b-43c2-8699-7ff72c5b709b', 'a8e1699d-78d1-4e07-81c8-08160ce13dba']}, {'title': 'list_51FLabels', 'value': ['WheelSpeedRR', 'Speed', 'WheelSpeedFL', 'WheelSpeedRL', 'WheelSpeedFR', 'AccelFB', 'AccelLR', 'AccelPedalAngle', 'EngineRPM']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'test new data'}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-09-24 20:44:41.415397",
                    "processedTime": "2398643.040298",
                    "subJobs": [
                        {
                            "id": "42070c7a-ac2b-4028-ad70-4bfe809329e0",
                            "job_name": null,
                            "user_inputs": "[{'fill_signals': ['Speed', 'AccelFB', 'AccelLR', 'EngineRPM'], 'aggregation': [], 'fill_type': 'forward', 'groupBy': []}, {'title': 'job_type', 'value': 'Prepared Data'}]",
                            "status": "In Progress",
                            "requestDateAndTime": "2024-09-25 18:38:50.275804",
                            "processedTime": "9e-06"
                        },
                        {
                            "id": "7bb40918-b085-4a18-944b-75cf07996815",
                            "job_name": null,
                            "user_inputs": "{'AccelLR': [Decimal('2'), Decimal('20')], 'AccelFB': [Decimal('1'), Decimal('10')]}",
                            "status": "Submitted",
                            "requestDateAndTime": "2024-10-21 20:07:06.951014",
                            "processedTime": "1e-05"
                        },
                        {
                            "id": "a43c4629-2f7a-468a-bf88-b485440589b7",
                            "job_name": null,
                            "user_inputs": "{'AccelLR': [Decimal('2'), Decimal('20')], 'AccelFB': [Decimal('1'), Decimal('10')]}",
                            "status": "Submitted",
                            "requestDateAndTime": "2024-10-21 20:07:06.295691",
                            "processedTime": "9e-06"
                        },
                        {
                            "id": "3797dc5d-11ab-4181-b159-d6a2b7aa88e5",
                            "job_name": null,
                            "user_inputs": "{'AccelLR': [Decimal('2'), Decimal('20')], 'AccelFB': [Decimal('1'), Decimal('10')]}",
                            "status": "Submitted",
                            "requestDateAndTime": "2024-10-21 20:07:07.873260",
                            "processedTime": "1.1e-05"
                        },
                        {
                            "id": "35d949b8-3d87-4439-b722-20bd02a2f100",
                            "job_name": null,
                            "user_inputs": "{'AccelLR': [Decimal('2'), Decimal('20')], 'AccelFB': [Decimal('1'), Decimal('10')]}",
                            "status": "Submitted",
                            "requestDateAndTime": "2024-10-21 20:07:07.064865",
                            "processedTime": "1.1e-05"
                        },
                        {
                            "id": "e69b9e09-e7dc-4838-b83b-5cee40775839",
                            "job_name": null,
                            "user_inputs": "{'AccelLR': [Decimal('2'), Decimal('20')], 'AccelFB': [Decimal('1'), Decimal('10')]}",
                            "status": "Submitted",
                            "requestDateAndTime": "2024-10-21 20:07:07.286914",
                            "processedTime": "1e-05"
                        },
                        {
                            "id": "951670a2-a295-4138-aefc-be528faa7644",
                            "job_name": null,
                            "user_inputs": "[{'fill_signals': ['Speed', 'AccelFB', 'AccelLR', 'WheelSpeedFL', 'EngineRPM'], 'agg_signals': ['Speed', 'WheelSpeedFL', 'AccelFB', 'AccelLR', 'EngineRPM'], 'aggregation': ['avg', 'max'], 'fill_type': 'forward', 'groupBy': ['By Vin']}, {'title': 'job_type', 'value': 'Prepared Data'}]",
                            "status": "Success",
                            "requestDateAndTime": "2024-11-01 18:20:19.140499",
                            "processedTime": "347.210025"
                        },
                        {
                            "id": "ccf997e9-e365-4860-a370-b4dff4628635",
                            "job_name": null,
                            "user_inputs": "{'AccelLR': [Decimal('2'), Decimal('20')], 'AccelFB': [Decimal('1'), Decimal('10')]}",
                            "status": "Submitted",
                            "requestDateAndTime": "2024-10-21 20:07:12.515886",
                            "processedTime": "1e-05"
                        },
                        {
                            "id": "c5441f50-69da-46d9-b354-f05e5cfe39f8",
                            "job_name": null,
                            "user_inputs": "{'AccelLR': [Decimal('2'), Decimal('20')], 'AccelFB': [Decimal('1'), Decimal('10')]}",
                            "status": "Submitted",
                            "requestDateAndTime": "2024-10-21 20:07:07.506320",
                            "processedTime": "9e-06"
                        },
                        {
                            "id": "4ede53b9-0630-4372-b47b-1cdba449f3a6",
                            "job_name": null,
                            "user_inputs": "[{'fill_signals': ['Speed', 'WheelSpeedFL', 'WheelSpeedRL', 'WheelSpeedFR', 'WheelSpeedRR', 'EngineRPM'], 'aggregation': [], 'fill_type': 'forward', 'groupBy': []}, {'title': 'job_type', 'value': 'Prepared Data'}]",
                            "status": "In Progress",
                            "requestDateAndTime": "2024-10-01 13:37:17.745510",
                            "processedTime": "9e-06"
                        }
                    ]
                }
            ]
        },
        {
            "id": "6e61da5a-2931-49f2-a17c-165850cad35b",
            "job_name": "test3",
            "user_inputs": "['05bc5498-9d26-45a5-bfa2-c801c6359a7e']",
            "status": "Success",
            "requestDateAndTime": "2024-04-04 19:13:04.054441",
            "processedTime": "328.311864",
            "subJobs": [
                {
                    "id": "92b6381e-3f3e-4a93-a676-c09f4f5c9025",
                    "job_name": "test3",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['Speed', 'ABSControl', 'AccelFB', 'AccelLR', 'TirePressureRL', 'TripCount']}, {'title': 'vins', 'value': ['9b535908-4358-4e06-93a4-bea0acaf2e50', '7093b1fb-7af9-4cc9-b6f0-fab26ca98c0a', 'f6dd2486-6017-4052-b2b7-961f5adfe9a2', '72dbc28e-4ce0-4755-bfa6-709b98a59d8b', 'b0adf1e7-74a3-4182-9720-d6e14497440a']}, {'title': 'job_type', 'value': 'Un-Nested Data'}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-05-21 18:08:28.248838",
                    "processedTime": "478.316239"
                }
            ]
        },
        {
            "id": "0f8b1dd4-710b-4630-aa76-3131b6b19f21",
            "job_name": "testere",
            "user_inputs": "['63881929-47fc-4588-9d58-1cbb8d9cdd3e']",
            "status": "Error",
            "requestDateAndTime": "2024-11-13 19:50:35.635397",
            "processedTime": "1.2e-05"
        },
        {
            "id": "2c13e01f-f36d-41ae-8fe7-3b99a94e2206",
            "job_name": "testnew1001",
            "user_inputs": "['7825c75d-579b-4aa8-aa5c-6b11f0e8697e', 'fc24d1d9-0b08-4992-b00d-442c1c2d3bf2', '05bc5498-9d26-45a5-bfa2-c801c6359a7e']",
            "status": "Error",
            "requestDateAndTime": "2024-10-01 13:43:17.223463",
            "processedTime": "7e-06"
        },
        {
            "id": "53f612d1-6774-4200-ab1f-3b1ca3397e6d",
            "job_name": "test",
            "user_inputs": "['fc24d1d9-0b08-4992-b00d-442c1c2d3bf2']",
            "status": "Error",
            "requestDateAndTime": "2025-01-06 20:02:39.040654",
            "processedTime": "8e-06"
        },
        {
            "id": "d962b422-7c27-48ce-a840-d24b7cd7ee1c",
            "job_name": "testnew",
            "user_inputs": "['379d6ba3-f564-4098-ba34-2ededd00e59d', '2c503f5a-3420-4b32-ba7b-31ab63508ea1', 'bd035272-c0ae-4958-b5d2-845383f1cecb', '80b79d5d-5841-45b9-96f1-4cf8aaa93c3c']",
            "status": "Success",
            "requestDateAndTime": "2024-05-29 22:15:18.205479",
            "processedTime": "408.762249",
            "subJobs": [
                {
                    "id": "dc73dcd4-c310-4ee3-89de-e07d361f1500",
                    "job_name": "testnew",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['VSCControl', 'PCSOpStateBrake', 'TripCount']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'Test Modal Year'}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-07-01 16:18:00.418230",
                    "processedTime": "498.663501"
                },
                {
                    "id": "a9582362-91ab-4666-a803-bb009a94415f",
                    "job_name": "testnew",
                    "user_inputs": "[{'title': 'vehicleName', 'value': ['PRIUS_PHV']}, {'title': 'list_51FLabels', 'value': ['Speed', 'TripCount']}, {'title': 'job_type', 'value': 'Un-Nested Data'}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-06-21 20:19:04.825569",
                    "processedTime": "489.694739",
                    "subJobs": [
                        {
                            "id": "8f1d0648-ae1f-47e6-8ef0-fec82a75cae5",
                            "job_name": null,
                            "user_inputs": "[{'fill_signals': ['Speed'], 'agg_signals': ['Speed'], 'aggregation': ['min', 'max'], 'fill_type': 'forward', 'groupBy': ['By Month', 'By Date']}, {'title': 'job_type', 'value': 'Prepared Data'}]",
                            "status": "Success",
                            "requestDateAndTime": "2024-07-11 16:55:52.905870",
                            "processedTime": "359.036907"
                        },
                        {
                            "id": "2b3f2fde-fb51-4f83-a528-d9946f84c6ca",
                            "job_name": null,
                            "user_inputs": "[{'agg_signals': ['Speed'], 'aggregation': ['max', 'min', 'avg', 'stddev'], 'fill_type': 'noFill', 'groupBy': ['By Vin', 'By Month', 'By Time', 'By DispatchModelType', 'By Date']}, {'title': 'job_type', 'value': 'Prepared Data'}]",
                            "status": "In Progress",
                            "requestDateAndTime": "2024-07-11 17:09:50.568266",
                            "processedTime": "1e-05"
                        },
                        {
                            "id": "ef6eb4bd-8e84-4019-acc6-93ac9919c9a5",
                            "job_name": null,
                            "user_inputs": "[{'fill_signals': ['Speed'], 'agg_signals': ['Speed'], 'aggregation': ['min', 'max'], 'fill_type': 'forward', 'groupBy': ['By Month', 'By Date']}, {'title': 'job_type', 'value': 'Prepared Data'}]",
                            "status": "Success",
                            "requestDateAndTime": "2024-07-11 16:30:53.800166",
                            "processedTime": "335.299479"
                        },
                        {
                            "id": "df4e6e41-fdd5-4387-ab15-bee4515cfb65",
                            "job_name": null,
                            "user_inputs": "[{'agg_signals': ['Speed'], 'aggregation': ['discrete_state_of_time', 'discrete_variables', 'discrete_state_as_perc'], 'fill_type': 'noFill', 'groupBy': ['By Month', 'By Date', 'By Vin']}, {'title': 'job_type', 'value': 'Prepared Data'}]",
                            "status": "Success",
                            "requestDateAndTime": "2024-07-11 20:32:45.568688",
                            "processedTime": "313734.896514"
                        },
                        {
                            "id": "4b266f75-3f3f-4b60-a242-25d87fca2671",
                            "job_name": null,
                            "user_inputs": "[{'fill_signals': ['Speed'], 'agg_signals': ['Speed'], 'aggregation': ['discrete_state_as_perc', 'discrete_variables', 'discrete_state_of_time'], 'fill_type': 'forward', 'groupBy': ['By Month', 'By Date', 'By Vin', 'By ModelYear']}, {'title': 'job_type', 'value': 'Prepared Data'}]",
                            "status": "Success",
                            "requestDateAndTime": "2024-07-11 20:40:18.460939",
                            "processedTime": "239.632047"
                        },
                        {
                            "id": "289fee7c-c63f-466b-b4a8-79d0cfb17a8b",
                            "job_name": null,
                            "user_inputs": "[{'agg_signals': ['Speed'], 'aggregation': ['max', 'min', 'avg', 'stddev'], 'fill_type': 'noFill', 'groupBy': ['By Vin', 'By Month', 'By Time', 'By DispatchModelType', 'By Date']}, {'title': 'job_type', 'value': 'Prepared Data'}]",
                            "status": "Success",
                            "requestDateAndTime": "2024-07-11 15:39:14.544012",
                            "processedTime": "320391.635314"
                        }
                    ]
                },
                {
                    "id": "7b3dcf3a-7c0c-4271-b718-524c67317e1b",
                    "job_name": "testnew",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['DoorLockPositionRL', 'VSCControl', 'PCSOpStateBrake', 'WheelSpeedRR', 'EstimateRoadGrade', 'HazardSwitch', 'DoorOpenP', 'StopLampControl', 'EcoModeInd', 'TransmissionType', 'RearFogLamp', 'TRCControl', 'TirePressureFL', 'LKAAssist_A', 'TirePressureRR', 'Odo', 'RearDefInd', 'BrakeWheelPressure', 'DefogInd', 'DoorLockPositionRR', 'TripCount', 'ACInd', 'AccelFB', 'ParkingBrake', 'FrontFogLamp', 'SmartBeamInd', 'WindowPositionRL', 'ATShiftPosition', 'BrakePedalPressure', 'BrakePedalInd', 'WindowPositionD', 'WindowPositionRR', 'ACStatus', 'HoodOpen', 'AccelLR', 'TurnSignal', 'DoorOpenD', 'Speed', 'AngularVelocity', 'RecIndicator', 'EngineRPM', 'SlideRoofPosition', 'AmbientTemp_A', 'ABSControl', 'SteeringAngle_A', 'PowerModeSelect_B', 'WindowPositionP', 'DoorOpenRR', 'SeatBeltD', 'WhiteLineSymbolL_A', 'WheelSpeedFL', 'DoorOpenB', 'EstimateMu', 'FrontBlowerLevel', 'PCSOpStateAlarm', 'TirePressureFR', 'DoorLockPositionD', 'HeadLamp_B', 'LKABuzzer_A', 'SportModeSelect', 'ShiftGear', 'WheelSpeedRL', 'FuelLevel', 'StateOfCharge', 'FuelConsumed', 'AccelPedalAngle', 'WhiteLineSymbolR_A', 'TirePressureRL', 'DoorLockPositionB', 'FuelGauge', 'TimeCount', 'TailLampStatus', 'DoorLockPositionP', 'SlideRoofExist', 'TempSettingD', 'WaterTemp_C', 'WheelSpeedFR', 'DoorOpenRL']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'Test New Trigger'}]",
                    "status": "Error",
                    "requestDateAndTime": "2024-07-18 14:01:02.390820",
                    "processedTime": "1e-05"
                },
                {
                    "id": "158982b2-5c0d-4da3-b966-dc2d3ef7aed4",
                    "job_name": "testnew",
                    "user_inputs": "[{'title': 'vehicleName', 'value': ['PRIUS_PHV']}, {'title': 'list_51FLabels', 'value': ['AccelLR', 'AccelFB', 'Speed', 'WheelSpeedFL', 'WheelSpeedRL', 'TripCount']}, {'title': 'DispatchModelType', 'value': ['ZVW52L-AHXEBA']}, {'title': 'vins', 'value': ['a2c16944-01a7-4f38-a531-8688caf13d58', '9b2236b7-b1bc-40d2-bf1e-ff9dd95f2a96']}, {'title': 'min_timestamp', 'value': '2024-01-02 04:00:00'}, {'title': 'max_timestamp', 'value': '2024-01-04 18:00:00'}, {'title': 'job_type', 'value': 'Un-Nested Data'}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-06-07 04:33:13.744433",
                    "processedTime": "487403.183823",
                    "subJobs": [
                        {
                            "id": "0a271f7f-3147-4cb5-b798-f23d193c6cf1",
                            "job_name": null,
                            "user_inputs": "[{'fill_signals': ['AccelLR', 'AccelFB', 'Speed', 'WheelSpeedFL', 'WheelSpeedRL'], 'agg_signals': ['AccelLR', 'AccelFB', 'Speed', 'WheelSpeedFL', 'WheelSpeedRL'], 'aggregation': ['max', 'min', 'avg', 'stddev', 'discrete_state_of_time', 'discrete_variables', 'discrete_state_as_perc'], 'fill_type': 'forward', 'groupBy': ['By Vin']}, {'title': 'job_type', 'value': 'Prepared Data'}]",
                            "status": "Success",
                            "requestDateAndTime": "2024-07-12 11:44:40.323169",
                            "processedTime": "381.829734"
                        },
                        {
                            "id": "fe1a4d36-f3d4-4164-bf3d-d34741fcb345",
                            "job_name": null,
                            "user_inputs": "[{'aggregation': ['stddev', 'min', 'avg', 'max', 'quartiles'], 'fill_type': 'forward', 'groupBy': ['By Vin', 'By DispatchModelType', 'By ModelYear'], 'signals': ['AccelLR', 'AccelFB', 'Speed', 'WheelSpeedFL']}, {'title': 'job_type', 'value': 'Prepared Data'}]",
                            "status": "Success",
                            "requestDateAndTime": "2024-06-19 13:00:00.917217",
                            "processedTime": "172786.087289"
                        },
                        {
                            "id": "90c957e9-651c-4adc-9681-2fca3ddf7053",
                            "job_name": null,
                            "user_inputs": "[{'fill_signals': ['AccelLR', 'AccelFB', 'Speed', 'WheelSpeedFL', 'WheelSpeedRL'], 'agg_signals': ['AccelLR', 'AccelFB', 'Speed', 'WheelSpeedFL', 'WheelSpeedRL'], 'aggregation': ['max', 'min', 'avg', 'stddev', 'discrete_state_of_time', 'discrete_variables', 'discrete_state_as_perc'], 'fill_type': 'forward', 'groupBy': ['By Vin']}, {'title': 'job_type', 'value': 'Prepared Data'}]",
                            "status": "Success",
                            "requestDateAndTime": "2024-07-11 20:57:42.395928",
                            "processedTime": "1015228.28228"
                        },
                        {
                            "id": "e9918208-c3ac-4fe7-836f-706e45b78377",
                            "job_name": null,
                            "user_inputs": "{'AccelLR': {'max': '43', 'min': '32'}, 'AccelFB': {'max': '432', 'min': '43'}}",
                            "status": "Success",
                            "requestDateAndTime": "2024-06-12 19:51:44.389117",
                            "processedTime": "292.448416"
                        }
                    ]
                },
                {
                    "id": "449a0530-05dc-4a7c-9a86-bb43783060fd",
                    "job_name": "testnew",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['VSCControl']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'test trigger'}]",
                    "status": "Error",
                    "requestDateAndTime": "2024-07-18 14:30:41.066242",
                    "processedTime": "1e-05"
                },
                {
                    "id": "4027ce4a-23ab-445e-b271-11b243f07b7e",
                    "job_name": "testnew",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['VSCControl', 'PCSOpStateBrake', 'TripCount']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'Test Job Modal Year'}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-07-01 16:17:10.691374",
                    "processedTime": "521.414197"
                },
                {
                    "id": "207b7151-09f1-404f-882e-15ea158b55af",
                    "job_name": "testnew",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['Speed', 'TirePressureFL', 'WheelSpeedFL', 'WheelSpeedRL', 'WheelSpeedFR', 'WheelSpeedRR', 'AngularVelocity', 'AccelLR', 'AccelFB', 'AccelPedalAngle', 'TripCount']}, {'title': 'vins', 'value': ['d5cd694a-93dd-4c86-8b8c-e44fc6119221', 'a4d37798-c9de-40d4-ae06-9bd64557acfa', '78186aff-733e-4cdf-a6c7-e103ecb53a7e', 'a2c16944-01a7-4f38-a531-8688caf13d58', '4a22c99f-d9f5-4fcf-8e7c-dec3d9393317', '5e640491-ee4a-44dd-925a-c41ff7992ca3', '4020c8fa-986f-4c13-950b-980b82b22b8a', 'a6317921-2047-4abb-938b-22c7f626e3eb']}, {'title': 'job_type', 'value': 'Un-Nested Data'}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-06-05 04:39:52.824876",
                    "processedTime": "1412635.111812",
                    "subJobs": [
                        {
                            "id": "2836f77c-f641-4834-b157-7088d0820532",
                            "job_name": null,
                            "user_inputs": "[{'fill_signals': ['Speed', 'TirePressureFL'], 'aggregation': [], 'fill_type': 'forward', 'groupBy': []}, {'title': 'job_type', 'value': 'Prepared Data'}]",
                            "status": "In Progress",
                            "requestDateAndTime": "2024-07-02 18:21:38.441275",
                            "processedTime": "1e-05"
                        },
                        {
                            "id": "e2845952-ee60-46e8-aa6b-178fab140854",
                            "job_name": null,
                            "user_inputs": "[{'aggregation': [], 'fill_type': 'forward', 'groupBy': [], 'signals': ['Speed', 'TirePressureFL']}, {'title': 'job_type', 'value': 'Prepared Data'}]",
                            "status": "Success",
                            "requestDateAndTime": "2024-07-01 15:05:42.825667",
                            "processedTime": "437.73494"
                        },
                        {
                            "id": "a87d56d4-8051-4cd4-8486-83a6d9f91382",
                            "job_name": null,
                            "user_inputs": "[{'fill_signals': ['Speed'], 'agg_signals': ['Speed'], 'aggregation': ['max', 'perc_input'], 'fill_type': 'forward', 'groupBy': ['By Vin'], 'percentile': Decimal('51')}, {'title': 'job_type', 'value': 'Prepared Data'}]",
                            "status": "Success",
                            "requestDateAndTime": "2024-07-18 13:10:03.666270",
                            "processedTime": "247.030356"
                        },
                        {
                            "id": "7dfda18e-297f-4b68-9236-05782e6158b4",
                            "job_name": null,
                            "user_inputs": "[{'fill_signals': ['Speed'], 'aggregation': [], 'fill_type': 'forward', 'groupBy': []}, {'title': 'job_type', 'value': 'Prepared Data'}]",
                            "status": "In Progress",
                            "requestDateAndTime": "2024-07-02 18:22:27.470077",
                            "processedTime": "9e-06"
                        },
                        {
                            "id": "cc240822-de49-4448-897a-bf56efd26ffe",
                            "job_name": null,
                            "user_inputs": "{'WheelSpeedFL': {'max': '4324', 'min': '42323'}, 'Speed': {'max': '243', 'min': '543'}, 'WheelSpeedRL': {'max': '6'}, 'TirePressureFL': {'max': '4234', 'min': '423'}}",
                            "status": "Success",
                            "requestDateAndTime": "2024-06-11 20:15:16.004086",
                            "processedTime": "838111.835358"
                        },
                        {
                            "id": "9db5c06e-7253-45b9-9f36-ef91d9487bd2",
                            "job_name": null,
                            "user_inputs": "[{'agg_signals': ['Speed', 'TirePressureFL', 'WheelSpeedFL', 'WheelSpeedRL', 'WheelSpeedFR', 'WheelSpeedRR', 'AngularVelocity', 'AccelLR', 'AccelFB', 'AccelPedalAngle'], 'aggregation': ['max', 'min', 'avg', 'stddev', 'quartiles', 'discrete_state_of_time', 'discrete_variables', 'perc_input', 'discrete_state_as_perc'], 'fill_type': 'noFill', 'groupBy': ['By Month', 'By Date', 'By Vin', 'By Time', 'By DispatchModelType', 'By ModelYear', 'By VehicleName']}, {'title': 'job_type', 'value': 'Prepared Data'}]",
                            "status": "Error",
                            "requestDateAndTime": "2024-07-10 21:04:39.545581",
                            "processedTime": "2e-05"
                        },
                        {
                            "id": "35ef8701-1cd8-430c-8ce3-f90c5d6d8892",
                            "job_name": null,
                            "user_inputs": "[{'aggregation': ['min', 'max', 'avg'], 'fill_type': 'forward', 'groupBy': ['By Vin'], 'signals': ['Speed']}, {'title': 'job_type', 'value': 'Prepared Data'}]",
                            "status": "Success",
                            "requestDateAndTime": "2024-06-05 13:34:36.793139",
                            "processedTime": "439.87309"
                        },
                        {
                            "id": "605efb46-dbc4-482c-af8b-ff3d0dcc352b",
                            "job_name": null,
                            "user_inputs": "[{'fill_signals': ['Speed'], 'agg_signals': ['Speed'], 'aggregation': ['max', 'perc_input'], 'fill_type': 'forward', 'groupBy': ['By Vin']}, {'title': 'job_type', 'value': 'Prepared Data'}]",
                            "status": "Error",
                            "requestDateAndTime": "2024-07-18 13:03:28.350538",
                            "processedTime": "1e-05"
                        },
                        {
                            "id": "3660b01e-caf5-4a15-a637-1204caad4bea",
                            "job_name": null,
                            "user_inputs": "[{'fill_signals': ['Speed'], 'agg_signals': ['Speed'], 'aggregation': ['max', 'min', 'avg', 'stddev', 'quartiles', 'discrete_state_of_time', 'discrete_variables', 'perc_input', 'discrete_state_as_perc'], 'fill_type': 'forward', 'groupBy': ['By Month', 'By Date', 'By Vin', 'By Time', 'By DispatchModelType', 'By ModelYear', 'By VehicleName'], 'percentile': Decimal('50')}, {'title': 'job_type', 'value': 'Prepared Data'}]",
                            "status": "Success",
                            "requestDateAndTime": "2024-07-18 13:19:02.062848",
                            "processedTime": "246.417596"
                        },
                        {
                            "id": "7655109f-2cda-43c8-907e-b30e4f2664a2",
                            "job_name": null,
                            "user_inputs": "[{'aggregation': ['min', 'max', 'stddev', 'avg'], 'fill_type': 'backward', 'groupBy': ['By Time', 'By Month', 'By Vin'], 'signals': ['Speed', 'TirePressureFL']}, {'title': 'job_type', 'value': 'Prepared Data'}]",
                            "status": "Success",
                            "requestDateAndTime": "2024-07-01 15:06:20.178054",
                            "processedTime": "377.381203"
                        },
                        {
                            "id": "e87f0c48-2678-416e-a6a4-7911feaef530",
                            "job_name": null,
                            "user_inputs": "[{'agg_signals': ['Speed', 'TirePressureFL', 'AccelFB', 'AccelLR'], 'aggregation': ['max', 'min', 'avg'], 'fill_type': 'noFill', 'groupBy': ['By Month', 'By Date', 'By Vin', 'By Time', 'By DispatchModelType']}, {'title': 'job_type', 'value': 'Prepared Data'}]",
                            "status": "Error",
                            "requestDateAndTime": "2024-07-10 21:50:46.975049",
                            "processedTime": "9e-06"
                        }
                    ]
                },
                {
                    "id": "523f3cfd-ff5f-4b49-a157-f42a827746f1",
                    "job_name": "testnew",
                    "user_inputs": "[{'title': 'vins', 'value': ['4020c8fa-986f-4c13-950b-980b82b22b8a']}, {'title': 'list_CanLabels', 'value': ['622_SB_IND', '61F_EV_ODO']}, {'title': 'list_51FLabels', 'value': ['HoodOpen', 'TurnSignal']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'test vin submit'}]",
                    "status": "Error",
                    "requestDateAndTime": "2024-07-24 15:29:31.829760",
                    "processedTime": "8e-06"
                },
                {
                    "id": "648336f4-f42e-42ea-94fc-614b54c84f95",
                    "job_name": "testnew",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['HazardSwitch']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'test data prop'}]",
                    "status": "Error",
                    "requestDateAndTime": "2024-07-18 14:34:55.060964",
                    "processedTime": "1e-05"
                },
                {
                    "id": "01d74f68-a451-40ee-b259-c3577b3d0c0c",
                    "job_name": "testnew",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['EstimateRoadGrade']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'test new trigger'}]",
                    "status": "Error",
                    "requestDateAndTime": "2024-07-18 14:32:42.818474",
                    "processedTime": "9e-06"
                },
                {
                    "id": "01b41990-e657-445f-bd0e-0a8290fcc28f",
                    "job_name": "testnew",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['DoorLockPositionRL', 'VSCControl', 'PCSOpStateBrake', 'WheelSpeedRR', 'EstimateRoadGrade', 'HazardSwitch', 'DoorOpenP', 'StopLampControl', 'EcoModeInd', 'TransmissionType', 'RearFogLamp', 'TRCControl', 'TirePressureFL', 'LKAAssist_A', 'TirePressureRR', 'Odo', 'RearDefInd', 'BrakeWheelPressure', 'DefogInd', 'DoorLockPositionRR', 'TripCount', 'ACInd', 'AccelFB', 'ParkingBrake', 'FrontFogLamp', 'SmartBeamInd', 'WindowPositionRL', 'ATShiftPosition', 'BrakePedalPressure', 'BrakePedalInd', 'WindowPositionD', 'WindowPositionRR', 'ACStatus', 'HoodOpen', 'AccelLR', 'TurnSignal', 'DoorOpenD', 'Speed', 'AngularVelocity', 'RecIndicator', 'EngineRPM', 'SlideRoofPosition', 'AmbientTemp_A', 'ABSControl', 'SteeringAngle_A', 'PowerModeSelect_B', 'WindowPositionP', 'DoorOpenRR', 'SeatBeltD', 'WhiteLineSymbolL_A', 'WheelSpeedFL', 'DoorOpenB', 'EstimateMu', 'FrontBlowerLevel', 'PCSOpStateAlarm', 'TirePressureFR', 'DoorLockPositionD', 'HeadLamp_B', 'LKABuzzer_A', 'SportModeSelect', 'ShiftGear', 'WheelSpeedRL', 'FuelLevel', 'StateOfCharge', 'FuelConsumed', 'AccelPedalAngle', 'WhiteLineSymbolR_A', 'TirePressureRL', 'DoorLockPositionB', 'FuelGauge', 'TimeCount', 'TailLampStatus', 'DoorLockPositionP', 'SlideRoofExist', 'TempSettingD', 'WaterTemp_C', 'WheelSpeedFR', 'DoorOpenRL']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'test trigger'}]",
                    "status": "Error",
                    "requestDateAndTime": "2024-07-18 14:02:44.991153",
                    "processedTime": "9e-06"
                }
            ]
        },
        {
            "id": "a728f9e2-8d6e-4b37-af37-3f34998cb002",
            "job_name": "testjan9",
            "user_inputs": "['baccc108-fb53-4467-8070-d86dda515406']",
            "status": "Success",
            "requestDateAndTime": "2025-01-09 16:06:40.375783",
            "processedTime": "748.330946",
            "subJobs": [
                {
                    "id": "eebd16cf-bd3d-491e-8cb3-1d06d1868a5f",
                    "job_name": "testjan9",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['Speed', 'WheelSpeedFL', 'WheelSpeedFR', 'WheelSpeedRL', 'WheelSpeedRR', 'TirePressureFL_TypeB', 'DoorLockPositionB', 'DoorLockPositionP', 'DoorLockPositionD']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'testjan30'}]",
                    "status": "Success",
                    "requestDateAndTime": "2025-01-30 19:58:41.227872",
                    "processedTime": "809.728206"
                },
                {
                    "id": "64f460d2-90bb-474a-80a1-7768689a25ef",
                    "job_name": "testjan9",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['AccelFB', 'AccelLR']}, {'title': 'vehicleName', 'value': [['TUNDRA']]}, {'title': 'ModelYear', 'value': [['2022']]}, {'title': 'FamilyName', 'value': [['787W']]}, {'title': 'DispatchModelType', 'value': [['VXKA70L-PSUSZA']]}, {'title': 'vins', 'value': ['5TFLA5AB6NX001014']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'unnestjan10'}]",
                    "status": "Error",
                    "requestDateAndTime": "2025-01-10 13:52:19.249931",
                    "processedTime": "9e-06"
                }
            ]
        },
        {
            "id": "d758679a-69f5-43dd-b66b-a36cd141f897",
            "job_name": "test7",
            "user_inputs": "['05bc5498-9d26-45a5-bfa2-c801c6359a7e']",
            "status": "Error",
            "requestDateAndTime": "2024-09-30 17:56:17.797304",
            "processedTime": "6e-06"
        },
        {
            "id": "3046becb-353c-4006-bc84-a3d9bdfa295f",
            "job_name": "testnew1",
            "user_inputs": "['4b81eea1-0d2a-48cf-addb-56a55ba57260']",
            "status": "Success",
            "requestDateAndTime": "2024-12-16 15:52:11.585610",
            "processedTime": "638.403246"
        },
        {
            "id": "f3217f8c-7d92-44c7-9823-d9e29e9b572a",
            "job_name": "testeere",
            "user_inputs": "['2d408118-8f16-458b-bf2a-fb5d5cac5424']",
            "status": "Success",
            "requestDateAndTime": "2024-11-11 17:24:53.393157",
            "processedTime": "1141.050402",
            "subJobs": [
                {
                    "id": "453cc78b-ac6c-4aad-9a18-703fbb3fd854",
                    "job_name": "testeere",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['Speed', 'WheelSpeedFL', 'WheelSpeedRL', 'AccelFB', 'AccelLR', 'EngineRPM']}, {'title': 'vins', 'value': ['6f6f8ff8-8143-47b9-b38b-5ad53be63613', '067f2e51-c9fb-44dc-9f0d-67d00e4126f4', 'a24618c3-3de6-41c8-9570-b7829341e375', '143f4c79-af94-4b66-86f9-3d0935e5c7cd', '31a0227a-51f5-4094-8927-40fbd7ac7fc8', '2c5e5baf-ccf4-43a3-97c7-f588d1167b7b']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'Test 11112024'}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-11-12 03:33:26.317622",
                    "processedTime": "1856.521986",
                    "subJobs": [
                        {
                            "id": "b617d6f5-1f42-4c5b-889c-34afe4324555",
                            "job_name": null,
                            "user_inputs": "[{'fill_signals': ['Speed', 'WheelSpeedFL', 'WheelSpeedRL', 'AccelFB', 'AccelLR', 'EngineRPM'], 'agg_signals': ['Speed', 'WheelSpeedFL', 'WheelSpeedRL', 'AccelFB', 'AccelLR', 'EngineRPM'], 'aggregation': ['min', 'avg', 'max'], 'fill_type': 'forward', 'groupBy': ['By Vin']}, {'title': 'job_type', 'value': 'Prepared Data'}]",
                            "status": "Success",
                            "requestDateAndTime": "2024-11-12 04:16:20.033195",
                            "processedTime": "586.092538"
                        }
                    ]
                },
                {
                    "id": "7a407044-749a-43a0-95e6-f8e683e9e9fd",
                    "job_name": "testeere",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['DoorLockPositionRL', 'VSCControl', 'PCSOpStateBrake', 'RadarCruiseExist', 'WheelSpeedRR']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'newtest0304'}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-11-11 20:27:35.524992",
                    "processedTime": "3366.313826"
                }
            ]
        },
        {
            "id": "7e046abc-24ab-4af9-b86a-e08d10c09226",
            "job_name": "jan22test",
            "user_inputs": "['5965a84d-3a8d-44b0-b70a-9d23838fd8c3']",
            "status": "Success",
            "requestDateAndTime": "2025-01-22 14:11:47.123703",
            "processedTime": "837.315351",
            "subJobs": [
                {
                    "id": "a97cc7a4-5056-456e-a0a4-ca3ae00a8a33",
                    "job_name": "jan22test",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['ABSControl', 'AccelFB', 'AccelLR', 'Speed']}, {'title': 'list_CanLabels', 'value': ['116_EACCP', '381_I_RRDEF', '101_PMCS']}, {'title': 'vins', 'value': ['3TYLC5LN0RT000264']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'test new feb 7'}]",
                    "status": "Success",
                    "requestDateAndTime": "2025-02-07 18:48:39.254323",
                    "processedTime": "782.114888",
                    "subJobs": [
                        {
                            "id": "0a928ac0-1cd9-472d-8fab-3ac3d49696d5",
                            "job_name": null,
                            "user_inputs": "[{'agg_signals': ['116_EACCP', '381_I_RRDEF', '101_PMCS', 'ABSControl', 'AccelFB', 'AccelLR', 'Speed'], 'aggregation': ['max', 'min', 'avg', 'discrete_state_of_time', 'discrete_variables'], 'fill_type': 'noFill', 'groupBy': ['By Vin']}, {'title': 'job_type', 'value': 'Prepared Data'}]",
                            "status": "Success",
                            "requestDateAndTime": "2025-02-07 19:30:07.084101",
                            "processedTime": "387.671938"
                        }
                    ]
                },
                {
                    "id": "0f16aa22-ccff-4203-8135-757530391299",
                    "job_name": "jan22test",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['AccelFB']}, {'title': 'list_CanLabels', 'value': ['025_STS1']}, {'title': 'min_timestamp', 'value': '2024-11-01 00:00:00'}, {'title': 'max_timestamp', 'value': '2024-11-02 00:00:00'}, {'title': 'vehicleName', 'value': ['TACOMA']}, {'title': 'ModelYear', 'value': [['2024']]}, {'title': 'FamilyName', 'value': [['912W']]}, {'title': 'DispatchModelType', 'value': [['TZNH47L-PRVSZA']]}, {'title': 'vins', 'value': [['3TYLC5LN0RT000264']]}, {'title': 'plantName', 'value': [['TMMBC']]}, {'title': 'naOverseas', 'value': [['Y']]}, {'title': 'engineTypeCode', 'value': [['T24A']]}, {'title': 'engineFamilyCode', 'value': [['T24A-FTS']]}, {'title': 'powerTrainType', 'value': [['4WD']]}, {'title': 'driveTrainCategory', 'value': [['4WD']]}, {'title': 'transmissionType', 'value': [['8AT']]}, {'title': 'transmissionModel', 'value': [['AT']]}, {'title': 'partNumber', 'value': ['61012AK010', '65701AK030']}, {'title': 'partName', 'value': ['PANEL SUB-ASSY, FR DOOR HINGE SIDE, RH', 'PANEL SUB-ASSY, COWL SIDE, LH']}, {'title': 'vehicleHasClaimIndicator', 'value': ['Y']}, {'title': 'claimedPartNumber', 'value': ['*']}, {'title': 'claimedPartDescription', 'value': [['*']]}, {'title': 't1Code', 'value': [['*']]}, {'title': 't2Code', 'value': [['*']]}, {'title': 'fieldReportNumber', 'value': [['TQCN_DPR-241800097']]}, {'title': 'fieldReportStatus', 'value': [['Complete']]}, {'title': 'monthsInService', 'value': {'minValue': '1', 'maxValue': '4'}}, {'title': 'mileage', 'value': {'minValue': '100', 'maxValue': '5000'}}, {'title': 'frequency', 'value': '10'}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'test feb 5'}]",
                    "status": "Error",
                    "requestDateAndTime": "2025-02-05 15:20:32.542825",
                    "processedTime": "1e-05"
                },
                {
                    "id": "8f942714-7105-4a4c-b83e-681dfd8d948b",
                    "job_name": "jan22test",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['AccelFB', 'AccelLR', 'AccelPedalAngle', 'Speed']}, {'title': 'list_CanLabels', 'value': ['2F3_WHI_S', '2E5_RCBKLMET', '101_PWCS', '116_EACCP', '3BF_B_R', '412_SWSEXIST']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'test data'}]",
                    "status": "Success",
                    "requestDateAndTime": "2025-02-05 17:30:50.428940",
                    "processedTime": "748.58449",
                    "subJobs": [
                        {
                            "id": "307468bd-8c24-4f79-9bf6-d7c77053542b",
                            "job_name": null,
                            "user_inputs": "[{'agg_signals': ['116_EACCP', '3BF_B_R', '412_SWSEXIST'], 'aggregation': ['discrete_state_of_time', 'discrete_variables', 'discrete_state_as_perc'], 'fill_type': 'noFill', 'groupBy': ['By Vin']}, {'title': 'job_type', 'value': 'Prepared Data'}]",
                            "status": "Success",
                            "requestDateAndTime": "2025-02-05 17:55:34.951780",
                            "processedTime": "319.508285"
                        }
                    ]
                },
                {
                    "id": "8dcea661-4f19-4d36-ba19-46272725ec51",
                    "job_name": "jan22test",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['ABSControl']}, {'title': 'monthsInService', 'value': [Decimal('1')]}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'test1'}]",
                    "status": "Success",
                    "requestDateAndTime": "2025-02-05 06:22:29.776526",
                    "processedTime": "719.380099"
                },
                {
                    "id": "77246e11-3aef-4aac-ac6d-d092e86ba004",
                    "job_name": "jan22test",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['ABSControl']}, {'title': 'fieldReportStatus', 'value': ['Complete']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'test'}]",
                    "status": "Success",
                    "requestDateAndTime": "2025-02-05 06:19:41.137874",
                    "processedTime": "643.575666"
                }
            ]
        },
        {
            "id": "df19fb26-eb29-4579-ac60-aa261c66161e",
            "job_name": "test8",
            "user_inputs": "['05bc5498-9d26-45a5-bfa2-c801c6359a7e']",
            "status": "Success",
            "requestDateAndTime": "2024-04-04 22:26:29.974729",
            "processedTime": "357.890691",
            "subJobs": [
                {
                    "id": "0c7ac5ee-2f9b-47e3-9c12-0acaab915c6d",
                    "job_name": "test8",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['RearFogLamp', 'TripCount']}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-04-30 14:11:31.201895",
                    "processedTime": "712837.527991",
                    "subJobs": [
                        {
                            "id": "a0396a31-121d-4c97-b224-9a820f1ef913",
                            "job_name": null,
                            "user_inputs": "[{'aggregation': ['quartiles', 'stddev', 'min', 'avg', 'perc_input', 'max'], 'fill_type': 'forward', 'groupBy': ['By Month', 'By Date', 'By Vin', 'By Time', 'By DispatchModelType', 'By VehicleName', 'By ModelYear'], 'percentile': Decimal('25'), 'signals': ['RearFogLamp', 'TripCount']}, {'title': 'job_type', 'value': 'data_fill'}]",
                            "status": "In Progress",
                            "requestDateAndTime": "2024-05-14 12:46:51.491622",
                            "processedTime": "158700.283918"
                        },
                        {
                            "id": "7f0dafda-2087-4fb7-8fac-91746859a101",
                            "job_name": null,
                            "user_inputs": "[{'aggregation': ['max', 'min', 'avg', 'stddev', 'quartiles', 'Discrete State of Time', 'Discrete Variables', '% input', 'Discrete State (as a %)'], 'signals': ['TripCount'], 'fill_type': 'forward', 'groupBy': ['By Month', 'By Date', 'By Vin', 'By Time', 'By DispatchModelType', 'By ModelYear', 'By VehicleName']}, {'title': 'job_type', 'value': 'data_fill'}]",
                            "status": "In Progress",
                            "requestDateAndTime": "2024-05-09 14:59:59.454525",
                            "processedTime": "1.1e-05"
                        }
                    ]
                }
            ]
        },
        {
            "id": "1df148bc-7c6a-48e7-b2d1-08ccb3bb5d67",
            "job_name": "test",
            "user_inputs": "['fc24d1d9-0b08-4992-b00d-442c1c2d3bf2']",
            "status": "Error",
            "requestDateAndTime": "2024-11-11 16:32:57.917714",
            "processedTime": "6e-06"
        },
        {
            "id": "1d51da2e-3941-485f-9b96-e484bde260e4",
            "job_name": "test1",
            "user_inputs": "['05bc5498-9d26-45a5-bfa2-c801c6359a7e']",
            "status": "Success",
            "requestDateAndTime": "2024-04-04 18:59:27.603158",
            "processedTime": "354.060968"
        },
        {
            "id": "7652edfe-3c07-4a22-9f39-312a63da1497",
            "job_name": "testneeeee",
            "user_inputs": "['423aee43-dc6c-4ba6-9d5e-b55727ea693a']",
            "status": "Error",
            "requestDateAndTime": "2024-12-10 18:51:00.203966",
            "processedTime": "6e-06"
        },
        {
            "id": "4a4235f1-9372-4275-a34d-157acebf7686",
            "job_name": "eml",
            "user_inputs": "['2c503f5a-3420-4b32-ba7b-31ab63508ea1', 'bd035272-c0ae-4958-b5d2-845383f1cecb', '05bc5498-9d26-45a5-bfa2-c801c6359a7e', '80b79d5d-5841-45b9-96f1-4cf8aaa93c3c', '379d6ba3-f564-4098-ba34-2ededd00e59d']",
            "status": "Success",
            "requestDateAndTime": "2024-04-03 05:12:03.879419",
            "processedTime": "377.123862"
        },
        {
            "id": "47b11610-1fa4-4111-9011-b5087a02872f",
            "job_name": "test",
            "user_inputs": "['05bc5498-9d26-45a5-bfa2-c801c6359a7e']",
            "status": "Success",
            "requestDateAndTime": "2024-04-15 21:27:32.555436",
            "processedTime": "354.072911",
            "subJobs": [
                {
                    "id": "08ee8aa6-8871-4df5-9aac-5ab7953e186b",
                    "job_name": "test",
                    "user_inputs": "[{'title': 'list_CanLabels', 'value': ['381_I_RRDEF', '024_GS4S', '3B7_B_HZD', '0AA_VXRR']}, {'title': 'vehicleName', 'value': ['MIRAI']}, {'title': 'min_timestamp', 'value': '2024-03-04 06:00:00'}, {'title': 'max_timestamp', 'value': '2024-03-12 05:00:00'}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-04-25 13:37:08.496456",
                    "processedTime": "484.817073"
                },
                {
                    "id": "1a5f30e3-f5b8-40a3-919e-32e5bf0852fc",
                    "job_name": "test",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['AccelLR', 'AccelFB', 'Speed', 'ABSControl', 'TirePressureFR']}, {'title': 'latitudes', 'value': ['38.39791318159542', '35.51909371964401', '35.436197628097986', '38.50116127232157']}, {'title': 'longitudes', 'value': ['-94.17274475097658', '-93.22792053222658', '-94.39350128173828', '-95.64491271972656']}, {'title': 'Type', 'value': 'in_bond'}, {'title': 'job_type', 'value': 'Un Nested Job'}]",
                    "status": "Error",
                    "requestDateAndTime": "2024-05-02 15:42:37.167790",
                    "processedTime": "1e-05"
                }
            ]
        },
        {
            "id": "c2e118b0-d9b4-41d0-b348-66f333a0406c",
            "job_name": "test6",
            "user_inputs": "['05bc5498-9d26-45a5-bfa2-c801c6359a7e']",
            "status": "Success",
            "requestDateAndTime": "2024-07-26 15:50:46.713727",
            "processedTime": "611.821263",
            "subJobs": [
                {
                    "id": "6fb45848-4a7e-496b-91a4-b99421a06c9d",
                    "job_name": "test6",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['Speed', 'WheelSpeedRR', 'TripCount']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'test 2 signals'}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-08-07 13:24:00.502874",
                    "processedTime": "673.116316"
                }
            ]
        },
        {
            "id": "0171e321-2b2f-4b0f-a92a-a100d374d823",
            "job_name": "test2",
            "user_inputs": "['05bc5498-9d26-45a5-bfa2-c801c6359a7e']",
            "status": "Success",
            "requestDateAndTime": "2024-04-04 19:12:59.281352",
            "processedTime": "350.598659"
        },
        {
            "id": "a90e6f1c-a8ea-4a66-9ec8-8a9e791473c0",
            "job_name": "testmultiplemsg",
            "user_inputs": "['2c503f5a-3420-4b32-ba7b-31ab63508ea1', 'bd035272-c0ae-4958-b5d2-845383f1cecb', '80b79d5d-5841-45b9-96f1-4cf8aaa93c3c', '379d6ba3-f564-4098-ba34-2ededd00e59d']",
            "status": "Success",
            "requestDateAndTime": "2024-04-03 05:05:45.240285",
            "processedTime": "331.160246"
        },
        {
            "id": "ef001ac1-5760-40b6-a4b1-5aa17a2e9dad",
            "job_name": "testManual",
            "user_inputs": "['05bc5498-9d26-45a5-bfa2-c801c6359a7e']",
            "status": "Success",
            "requestDateAndTime": "2024-04-04 18:59:11.766765",
            "processedTime": "369.29948"
        },
        {
            "id": "18bd9fc4-5566-4589-a447-8127bfac9811",
            "job_name": "testdata",
            "user_inputs": "['baccc108-fb53-4467-8070-d86dda515406']",
            "status": "Success",
            "requestDateAndTime": "2024-12-30 20:15:35.874612",
            "processedTime": "644828.940427"
        },
        {
            "id": "9516ef7c-38cf-4048-8a03-d1bb6a16cd27",
            "job_name": "Updatetest",
            "user_inputs": "['baccc108-fb53-4467-8070-d86dda515406']",
            "status": "Success",
            "requestDateAndTime": "2025-01-07 17:01:21.561584",
            "processedTime": "742.593031"
        },
        {
            "id": "e35a79d3-27e8-4d6a-a25e-da463c8fd2ad",
            "job_name": "test7",
            "user_inputs": "['05bc5498-9d26-45a5-bfa2-c801c6359a7e']",
            "status": "Error",
            "requestDateAndTime": "2024-09-05 19:40:22.130328",
            "processedTime": "1.1e-05"
        },
        {
            "id": "ec47d537-a727-45b1-8c79-06d0d36b0ca5",
            "job_name": "tes",
            "user_inputs": "[]",
            "status": "Error",
            "requestDateAndTime": "2024-11-04 17:22:25.426051",
            "processedTime": "1.1e-05"
        },
        {
            "id": "6674ab7b-b40a-48a9-a37b-864fae8718b7",
            "job_name": "Newtest",
            "user_inputs": "['05bc5498-9d26-45a5-bfa2-c801c6359a7e']",
            "status": "Success",
            "requestDateAndTime": "2024-05-29 14:51:33.950271",
            "processedTime": "499.993739",
            "subJobs": [
                {
                    "id": "191366ea-9be9-47f1-bcf4-c1236ab1e59f",
                    "job_name": "Newtest",
                    "user_inputs": "[{'title': 'vins', 'value': ['1ed6afb1-c94a-4b64-a75d-326de5c48486', 'f6dd2486-6017-4052-b2b7-961f5adfe9a2', '72dbc28e-4ce0-4755-bfa6-709b98a59d8b', 'f7f3c84b-f6bc-4e82-9cb6-58bde6f5a4b5', '4eea7c87-9266-452d-bb93-5d7b16bb9b43']}, {'title': 'list_51FLabels', 'value': ['Speed', 'AccelLR', 'AccelFB', 'TripCount']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'jon_name', 'value': 'Un Nested Job Name Test'}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-06-21 20:27:07.641025",
                    "processedTime": "592.172344"
                },
                {
                    "id": "e2c39300-2400-4496-8390-69d2c0206487",
                    "job_name": "Newtest",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['Speed', 'AccelFB', 'AccelLR', 'AccelPedalAngle', 'TripCount']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'Unnest job test'}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-06-24 02:45:41.802919",
                    "processedTime": "706.793126"
                }
            ]
        },
        {
            "id": "c4be9177-8f85-4bef-bec1-fbf5aef6e664",
            "job_name": "testnew",
            "user_inputs": "['85fc8677-7eb7-4c21-877c-5e21b21ccb65']",
            "status": "Error",
            "requestDateAndTime": "2024-11-06 18:29:10.728900",
            "processedTime": "1.2e-05"
        },
        {
            "id": "57ba00f4-b5d3-439a-98a3-7e297cbb34b3",
            "job_name": "test9",
            "user_inputs": "['05bc5498-9d26-45a5-bfa2-c801c6359a7e']",
            "status": "Success",
            "requestDateAndTime": "2024-04-04 22:26:41.501317",
            "processedTime": "347.949653",
            "subJobs": [
                {
                    "id": "cfccf13f-4c95-4abc-9543-0972d949fef1",
                    "job_name": "test9",
                    "user_inputs": "[{'title': 'vehicleName', 'value': ['MIRAI']}, {'title': 'list_51FLabels', 'value': ['StopLampControl', 'VSCControl', 'WheelSpeedRR', 'TripCount']}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-04-25 14:18:26.833378",
                    "processedTime": "69635.567273",
                    "subJobs": [
                        {
                            "id": "91905caf-d4c8-4256-99df-59bd2602097b",
                            "job_name": null,
                            "user_inputs": "['VSCControl']",
                            "status": "In Progress",
                            "requestDateAndTime": "2024-04-30 19:03:22.688967",
                            "processedTime": "1e-05"
                        },
                        {
                            "id": "78ac15a8-4750-41ed-96ce-aaa8b0fa8271",
                            "job_name": null,
                            "user_inputs": "['StopLampControl', 'VSCControl']",
                            "status": "In Progress",
                            "requestDateAndTime": "2024-04-30 18:52:19.163400",
                            "processedTime": "8e-06"
                        },
                        {
                            "id": "44f6fefb-36b5-440b-9752-7d6a0939e30e",
                            "job_name": null,
                            "user_inputs": "['StopLampControl', 'VSCControl']",
                            "status": "In Progress",
                            "requestDateAndTime": "2024-04-30 18:52:19.410762",
                            "processedTime": "1e-05"
                        }
                    ]
                }
            ]
        },
        {
            "id": "7ecb3808-7aab-45f6-b484-7542ef9b45f1",
            "job_name": "testData",
            "user_inputs": "[]",
            "status": "Error",
            "requestDateAndTime": "2024-05-29 22:11:18.238113",
            "processedTime": "6e-06"
        },
        {
            "id": "863f9bf1-fe9e-4c40-a5bd-4cf2b27766cc",
            "job_name": "test1",
            "user_inputs": "['05bc5498-9d26-45a5-bfa2-c801c6359a7e']",
            "status": "Success",
            "requestDateAndTime": "2024-07-26 15:39:45.107663",
            "processedTime": "625.767858",
            "subJobs": [
                {
                    "id": "ac324184-7045-4a1d-b744-dff97368f02a",
                    "job_name": "test1",
                    "user_inputs": "[{'title': 'vehicleName', 'value': ['MIRAI']}, {'title': 'list_51FLabels', 'value': ['WheelSpeedRR', 'Speed', 'WheelSpeedFL', 'PCSOpStateBrake', 'AccelLR', 'TurnSignal', 'TirePressureFR', 'PCSOpStateAlarm', 'WheelSpeedFR', 'DoorOpenRL', 'TripCount']}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'Test Null Count'}]",
                    "status": "Success",
                    "requestDateAndTime": "2024-07-29 17:41:47.825451",
                    "processedTime": "902.291839"
                }
            ]
        },
        {
            "id": "321e07fd-28c1-4abf-94ae-e04bc9b51716",
            "job_name": "testfeb10",
            "user_inputs": "['5965a84d-3a8d-44b0-b70a-9d23838fd8c3']",
            "status": "Success",
            "requestDateAndTime": "2025-02-10 15:23:30.315403",
            "processedTime": "823.906673",
            "subJobs": [
                {
                    "id": "87265a70-9611-48b8-9eeb-9852f55d3894",
                    "job_name": "testfeb10",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['AccelFB', 'AccelLR', 'DoorLockPositionRR', 'DoorLockPositionRL']}, {'title': 'list_CanLabels', 'value': ['116_EACCP', '381_I_REC']}, {'title': 'odometer', 'value': {'minValue': '5000', 'maxValue': '500'}}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'test feb 11'}]",
                    "status": "Success",
                    "requestDateAndTime": "2025-02-11 20:59:38.849568",
                    "processedTime": "381.542286"
                },
                {
                    "id": "89300445-2ddf-40a6-b1d3-63cde5b464cc",
                    "job_name": "testfeb10",
                    "user_inputs": "[{'title': 'list_51FLabels', 'value': ['AccelLR', 'AccelFB', 'Speed', 'WheelSpeedFL']}, {'title': 'list_CanLabels', 'value': ['116_EACCP', '381_I_REC']}, {'title': 'odometer', 'value': {'minValue': '4520', 'maxValue': '4555'}}, {'title': 'job_type', 'value': 'Un-Nested Data'}, {'title': 'job_name', 'value': 'test new feb 13'}]",
                    "status": "Success",
                    "requestDateAndTime": "2025-02-13 16:06:03.401801",
                    "processedTime": "365.113097"
                }
            ]
        },
        {
            "id": "c98f568b-7a88-402d-a627-b74befe331cc",
            "job_name": "test",
            "user_inputs": "[]",
            "status": "Error",
            "requestDateAndTime": "2024-07-26 15:39:12.315278",
            "processedTime": "7e-06"
        },
        {
            "id": "0c46c5d6-10fb-42ce-86d0-fc4a56d6dead",
            "job_name": "testnewdata",
            "user_inputs": "['baccc108-fb53-4467-8070-d86dda515406']",
            "status": "In Progress",
            "requestDateAndTime": "2024-11-20 16:51:12.483760",
            "processedTime": "169238.070566"
        },
        {
            "id": "3b2286c6-f505-4126-a48f-2a55a59301ec",
            "job_name": "test",
            "user_inputs": "['fc24d1d9-0b08-4992-b00d-442c1c2d3bf2']",
            "status": "Error",
            "requestDateAndTime": "2025-01-06 20:07:54.573433",
            "processedTime": "6e-06"
        }
    ]
}

